<template>
	<div ref="body">
		<b-container
			fluid
			v-if="action_preset === null && !workflow"
			style="margin: 0px !important; padding: 0px !important">
			<b-row style="margin: 0px !important; padding: 0px !important">
				<b-col
					md="auto"
					style="margin: 0px !important; padding: 0px !important">
					<h3>Action</h3>

					<!-- Affichage texte du nom de l'action (v2) -->
					<div v-if="readonly_action" class="step-action-label">
						<span class="step-action-name">{{ actionLabelV2 }}</span>
						<span v-if="isLegacy" class="step-action-legacy-badge">legacy</span>
					</div>
					<!-- Cascader (v1) -->
					<vue-cascader-select
						v-else
						class="bg-white rounded-md z-10 text-black my-cascader-select"
						@select="(item) => setAction(item.value, item.label)"
						:value="actionLabel"
						:options="menu">
					</vue-cascader-select>
				</b-col>
				<b-col>
					<h3>Titre</h3>
					<b-form-input
						@change="change_emit()"
						v-model="description" />
				</b-col>
				<b-col
					md="auto"
					style="margin: 0px !important; padding: 0px !important">
					<div class="d-flex justify-content-end">
						<b-button
							variant="link"
							class="text-muted p-0"
							title="Fermer / retirer cette étape"
							@click="confirm_remove_step"
							><i class="fas fa-times"></i
						></b-button>
					</div>
					<b-button-group size="sm">
					<b-button
						v-b-modal="'modal-descriptions' + action_id"
						><i class="fas fa-comment-dots"></i
					></b-button>
					<b-modal
						:id="'modal-descriptions' + action_id"
						title="Commentaire et Description"
						size="xl"
						hide-footer>
						<h3>Description</h3>
						<b-textarea
							v-model="long_description"
							rows="15" />
					<div v-if="_canGenerateIa" class="d-flex align-items-center mt-2">
							<b-button variant="link" class="p-0" @click="generate_description">Générer la description</b-button>
							<b-button variant="link" class="p-0 ml-3 text-muted" @click="toggle_custom_prompt">
								<i class="fas fa-sliders-h"></i>
								{{ show_custom_prompt ? 'Masquer le prompt' : 'Personnaliser le prompt' }}
							</b-button>
							<b-button v-if="custom_prompt" variant="link" class="p-0 ml-2 text-danger" title="Réinitialiser le prompt" @click="custom_prompt = ''">
								<i class="fas fa-undo"></i>
							</b-button>
						</div>
						<b-collapse v-model="show_custom_prompt">
							<div class="mt-2 p-2 border rounded bg-light">
								<small class="text-muted d-block mb-1">
									Début du prompt envoyé à l'IA — les données de l'étape sont toujours ajoutées à la suite.
									<b-button variant="link" size="sm" class="p-0 ml-2" @click="prefill_custom_prompt">Réinitialiser</b-button>
								</small>
								<b-textarea v-model="custom_prompt" rows="10" />
							</div>
						</b-collapse>
						<h3>Commentaire</h3>
						<b-textarea
							v-model="comment"
							rows="5" />
						<br />
						<div v-show="spinner" class="center_spinner">
							<fade-loader></fade-loader>
						</div>
					</b-modal>
					<b-button
						@click="json_step = JSON.stringify(save(), null, 4)"
						v-b-modal="'modal-step' + action_id"
						><i class="fas fa-edit"></i
					></b-button>
					<b-modal
						:hide-footer="true"
						size="lg"
						:id="'modal-step' + action_id"
						title="JSON de l'étape">
						<b-form-textarea
							v-model="json_step"
							rows="15"></b-form-textarea>
						<b-button @click="apply_json_step()"
							>Appliquer</b-button
						>
					</b-modal>
					<b-button
						v-b-modal="'modal-step-options' + action_id"
						:variant="(step_strict || step_cut_start || step_cut_end || source_data_ids.length > 0) ? 'warning' : 'secondary'"
						><i class="fas fa-cog"></i
					></b-button>
					<b-modal
						:id="'modal-step-options' + action_id"
						title="Options d'exécution"
						hide-footer
						size="sm">
						<b-form-group label="Source data" label-size="sm" class="mb-1">
							<small class="text-muted d-block mb-2">Étapes sources de données :</small>
							<div v-if="steps_list.length === 0" class="text-muted small">
								Aucune autre étape disponible
							</div>
							<div
								v-for="s in steps_list"
								:key="s.uid"
								class="mb-1"
								:class="{ 'text-muted': s.position === step_position + 1 }">
								<b-form-checkbox
									v-model="source_data_ids"
									:value="s.uid"
									:disabled="s.position === step_position + 1"
									size="sm">
									<span class="text-muted mr-1">{{ s.position === 0 ? '↑' : s.position + '.' }}</span>{{ s.label }}
								</b-form-checkbox>
							</div>
						</b-form-group>
						<hr class="mt-2 mb-3" />
						<b-form-checkbox v-model="step_strict" class="mb-2">
							<strong>Strict</strong> — arrêter le traitement si cette étape renvoie une erreur
						</b-form-checkbox>
						<b-form-checkbox v-model="step_cut_start" class="mb-2">
							<strong>Cut start</strong> — forcer une coupure avant cette étape
						</b-form-checkbox>
						<b-form-checkbox v-model="step_cut_end">
							<strong>Cut end</strong> — forcer une coupure après cette étape
						</b-form-checkbox>
					</b-modal>
					<step_credentials_button
						v-if="_canManageCredentials && (_stepCredentialRequirements.length || _stepCredentialsFreeform)"
						:requirements="_stepCredentialRequirements"
						:freeform="_stepCredentialsFreeform"
						:modal-id="'modal-step-credentials' + action_id" />
					</b-button-group>
				</b-col>
			</b-row>
		</b-container>

		<!-- <div v-if="ActionComment[this.action]">
			{{ ActionComment[this.action] }}
		</div> -->

		<div v-show="lines_mode == 'steps'">
			<b-checkbox style="display: inline;" v-model="lines"></b-checkbox>Exécution par lots
		</div>

		<div v-show="c_conditions && !workflow">

			<div
				v-b-toggle="'collapse-conditions' + action_id"
				:style="data.rules ? 'font-weight: bold' : ''">
				Conditions <i v-if="!collapse" class="fas fa-plus"></i
				><i v-if="collapse" class="fas fa-minus"></i>
			</div>

			<b-collapse
				v-model="collapse"
				:id="'collapse-conditions' + action_id">
				<div :id="'builder-' + action_id"></div>
			</b-collapse>
		</div>
		<div v-show="c_tabulator">
			<br />
			<h3>Tableau</h3>
			<edit_tabulator
				:select_mode="true"
				:style="'max-width: ' + (size - 100) + 'px'"
				@update="setParameters"
				ref="edit_tabulator"
				:filename="name_file || 'data.csv'"
				:columns_type="columns_type"></edit_tabulator>
		</div>

		<div
			v-show="c_tree"
			v-if="typeof data === 'object' && Array.isArray(data) === false">
			<draggable-tree
				:style="'max-width: ' + (size - 100) + 'px'"
				@update="update_tree"
				ref="tree"
				:parameters="data"></draggable-tree>
		</div>

		<!-- * info sur la requete personnalisée -->
		<div class="mt-2" v-if="currentRequest != null">
			<request-perso-overview
				:value="currentRequest"
				@changedReq="(newVals) => modifyRequest(newVals)" />
		</div>

		<!-- * n'est plus vraiment utile puisqu'on a maintenant l'autocompletion  -->
		<!-- <div v-if="usesPrevColumnNames" class="w-25 my-4">
            Trier la suggestion des colonnes par:
            <b-form-select v-model="columnDropdownOrderPref">
                <option value="default">Defaut</option>
                <option value="alphabetical">Ordre alphabetique</option>
            </b-form-select>
        </div> -->

        <!-- Components custom pour 'remplacer' JSON editor solution rapide mais pas optimale -->
        <!-- Utiliser <component :is='action.tolowerCase()' https://vuejs.org/api/built-in-special-elements.html#component -->
        <!-- * trouver le moyen de passer des props différents? -->


		<div v-if="show_user_params_editor" v-show="!workflow">
			<div
				v-b-toggle="'collapse-user_params' + action_id"
				:style="user_params.length > 0 ? 'font-weight: bold' : ''">
				Paramètres de traitements <i v-if="!collapse_user_params" class="fas fa-plus"></i><i v-if="collapse_user_params" class="fas fa-minus"></i>
			</div>

			<b-collapse
				v-model="collapse_user_params"
				:id="'collapse-user_params' + action_id">
				<div v-if="treatment_params_elements.length > 0">
					Ajouter
					<b-button @click="add_treatment_params_element(idx)" v-for="(treatment_params_element, idx) in treatment_params_elements" :key="idx">{{ treatment_params_element.libelle }}</b-button>&nbsp;
				</div>
				<div :id="'builder-user-params-' + action_id"></div>
			</b-collapse>
		</div>

		<!-- ── Panneau Paramètres du scénario (Phase 4) ── -->
		<div v-show="!simple_mode && !workflow" class="mt-2">
			<div
				v-b-toggle="'collapse-scenario-params-' + action_id"
				class="d-flex align-items-center"
				style="cursor:pointer; user-select:none"
				:style="params_targeting_this_step.length > 0 ? 'font-weight:bold' : ''">
				<span>Paramètres du scénario</span>
				<b-badge v-if="params_targeting_this_step.length > 0" variant="primary" pill class="ml-1" style="font-size:.65rem">{{ params_targeting_this_step.length }}</b-badge>
				<i v-if="!collapse_scenario_params" class="fas fa-plus ml-1"></i>
				<i v-else class="fas fa-minus ml-1"></i>
			</div>

			<b-collapse v-model="collapse_scenario_params" :id="'collapse-scenario-params-' + action_id">
				<div class="mt-2 p-2 border rounded" style="background:#f8f9fa">

					<!-- Script : tous les params accessibles + création possible -->
					<template v-if="sp_is_script">
						<p class="text-muted small mb-2">
							<i class="fas fa-info-circle mr-1"></i>
							Tous les paramètres du scénario sont accessibles via <code>treatment_params</code> dans ce script.
						</p>
						<table class="table table-sm table-borderless mb-1" style="font-size:.82rem">
							<thead><tr class="text-muted"><th>Nom</th><th>Libellé</th><th>Valeur de test</th><th></th></tr></thead>
							<tbody>
								<tr v-for="p in scenario_params" :key="p.name">
									<td><code>{{ p.name }}</code></td>
									<td class="text-muted">{{ p.libelle || '' }}</td>
									<td>
										<span v-if="p.value !== undefined && p.value !== p.default_value"
											v-b-tooltip.hover :title="'Valeur par défaut : ' + (p.default_value || '(vide)')">{{ p.value }}</span>
										<span v-else class="text-muted">
											<span v-if="p.default_value !== undefined && p.default_value !== ''">{{ p.default_value }}</span>
											<span v-else style="font-style:italic;opacity:.6">(vide)</span>
										</span>
									</td>
									<td>
										<b-button size="sm" variant="link" class="p-0" v-b-tooltip.hover title="Modifier ce paramètre" @click="$emit('edit_scenario_param', p.name)">
											<i class="fas fa-edit fa-sm"></i>
										</b-button>
									</td>
								</tr>
							</tbody>
						</table>
						<div v-if="!sp_show_form" class="mt-1 d-flex align-items-center" style="gap:8px">
						<b-button size="sm" variant="outline-primary" @click="$emit('open_create_scenario_param', data && data.uid)">
								<i class="fas fa-plus mr-1"></i>Créer un paramètre
							</b-button>
							<span class="text-muted small">Pour supprimer, utilisez la section « Paramètres de traitement » du scénario.</span>
						</div>
					</template>

					<!-- Étape Projet : params du projet fils -->
					<template v-else-if="c_project">
						<div v-if="params_targeting_this_step.length === 0" class="text-muted small mb-2">
							Aucun paramètre du scénario ne cible ce projet.
						</div>
						<div
							v-for="p in params_targeting_this_step"
							:key="p.name"
							class="d-flex align-items-center border-bottom py-1 small"
						>
							<div class="flex-grow-1">
								<strong>{{ p.libelle || p.name }}</strong>
								<code class="text-muted ml-1">{{ p.name }}</code>
								<span class="text-muted ml-1" style="font-size:.75rem">
									→ {{ (p.targets || []).filter(t => t.step_uid === (data && data.uid)).map(t => t.param_name || t.jsonpath).join(', ') }}
								</span>
							</div>
							<b-button size="sm" variant="link" class="p-0 mr-1" v-b-tooltip.hover title="Modifier ce paramètre" @click="$emit('edit_scenario_param', p.name)">
								<i class="fas fa-edit fa-sm"></i>
							</b-button>
							<b-button size="sm" variant="link" class="p-0 text-danger" v-b-tooltip.hover title="Retirer" @click="sp_remove_target(p.name)">
								<i class="fas fa-unlink fa-sm"></i>
							</b-button>
						</div>

						<div v-if="!sp_show_form" class="mt-2 d-flex" style="gap:6px">
							<b-button v-if="sp_link_options.length > 0" size="sm" variant="outline-secondary" @click="sp_open_form('link')">
								<i class="fas fa-link mr-1"></i>Associer un paramètre
							</b-button>
							<b-button size="sm" variant="outline-primary" @click="$emit('open_create_scenario_param', data && data.uid)">
								<i class="fas fa-plus mr-1"></i>Créer un paramètre
							</b-button>
						</div>

						<!-- Form créer / associer pour projet -->
						<div v-if="sp_show_form" class="mt-2 p-2 border rounded" style="background:#fff">
							<template v-if="sp_mode === 'link'">
								<b-form-group label="Paramètre existant" class="mb-1">
									<b-form-select v-model="sp_link_name" :options="[{ value: null, text: '— Choisir —' }, ...sp_link_options]" size="sm"></b-form-select>
								</b-form-group>
							</template>
							<template v-else>
								<b-row>
									<b-col cols="6">
										<b-form-group label="Nom" class="mb-1">
											<b-input v-model="sp_new_name" size="sm" placeholder="ex: start_date" trim></b-input>
										</b-form-group>
									</b-col>
									<b-col cols="6">
										<b-form-group label="Libellé" class="mb-1">
											<b-input v-model="sp_new_libelle" size="sm" placeholder="ex: Date de début" trim></b-input>
										</b-form-group>
									</b-col>
								</b-row>
							</template>
							<!-- Param du projet fils -->
							<b-form-group label="Paramètre du projet fils" class="mb-1">
								<b-form-select
									v-if="treatment_params && treatment_params.length > 0"
									v-model="sp_new_param_name"
									:options="[{ value: '', text: '— Sélectionner —' }, ...treatment_params.map(p => ({ value: p.name, text: (p.libelle || p.name) + ' (' + p.name + ')' }))]"
									size="sm"
									@change="sp_on_projet_param_select"
								></b-form-select>
								<b-input v-else v-model="sp_new_param_name" size="sm" placeholder="nom_du_parametre" trim></b-input>
							</b-form-group>
							<div v-if="sp_error" class="text-danger small mb-1">{{ sp_error }}</div>
							<div class="d-flex" style="gap:6px">
								<b-button size="sm" variant="primary" @click="sp_submit">{{ sp_mode === 'link' ? 'Associer' : 'Créer' }}</b-button>
								<b-button size="sm" variant="link" @click="sp_close_form">Annuler</b-button>
							</div>
						</div>
					</template>

					<!-- Étapes normales : params qui ciblent cette étape -->
					<template v-else>
						<div v-if="params_targeting_this_step.length === 0" class="text-muted small mb-2">
							Aucun paramètre du scénario ne cible cette étape.
						</div>
						<div
							v-for="p in params_targeting_this_step"
							:key="p.name"
							class="d-flex align-items-center border-bottom py-1 small"
						>
							<div class="flex-grow-1">
								<strong>{{ p.libelle || p.name }}</strong>
								<code class="text-muted ml-1">{{ p.name }}</code>
							</div>
							<span class="mx-2" style="font-size:.8rem">
								<span v-if="p.value !== undefined && p.value !== p.default_value"
									v-b-tooltip.hover :title="'Valeur par défaut : ' + (p.default_value || '(vide)')">{{ p.value }}</span>
								<span v-else class="text-muted">
									<span v-if="p.default_value !== undefined && p.default_value !== ''">{{ p.default_value }}</span>
									<span v-else style="font-style:italic;opacity:.6">(vide)</span>
								</span>
							</span>
							<code class="text-muted mr-1" style="font-size:.75rem">
								{{ (p.targets || []).filter(t => t.step_uid === (data && data.uid)).map(t => t.jsonpath || ('param_name: ' + t.param_name)).join(', ') }}
							</code>
							<b-button size="sm" variant="link" class="p-0 mr-1" v-b-tooltip.hover title="Modifier ce paramètre" @click="$emit('edit_scenario_param', p.name)">
								<i class="fas fa-edit fa-sm"></i>
							</b-button>
							<b-button
								size="sm" variant="link" class="p-0 text-danger"
								v-b-tooltip.hover title="Retirer ce paramètre de cette étape (le paramètre reste dans le scénario)"
								@click="sp_remove_target(p.name)"
							><i class="fas fa-unlink fa-sm"></i></b-button>
						</div>
						
						<!-- Form associer / créer -->
						<div v-if="!sp_show_form" class="mt-2 d-flex" style="gap:6px">
							<b-button
								v-if="sp_link_options.length > 0"
								size="sm" variant="outline-secondary"
								@click="sp_open_form('link')"
							><i class="fas fa-link mr-1"></i>Associer un paramètre</b-button>
							<b-button
								size="sm" variant="outline-primary"
								@click="$emit('open_create_scenario_param', data && data.uid)"
							><i class="fas fa-plus mr-1"></i>Créer un paramètre</b-button>
						</div>
					</template>

					<!-- Formulaire commun (créer/associer) — pas pour c_project qui a son propre formulaire -->
					<div v-if="sp_show_form && !c_project" class="mt-2 p-2 border rounded" style="background:#fff">
						<!-- Mode associer (étapes normales uniquement) -->
						<template v-if="sp_mode === 'link'">
							<b-form-group label="Paramètre existant" class="mb-1">
								<b-form-select v-model="sp_link_name" :options="[{ value: null, text: '— Choisir —' }, ...sp_link_options]" size="sm"></b-form-select>
							</b-form-group>
						</template>
						<!-- Mode créer -->
						<template v-else>
							<b-row>
								<b-col cols="5">
									<b-form-group label="Nom" class="mb-1">
										<b-input v-model="sp_new_name" size="sm" placeholder="ex: start_date" trim></b-input>
									</b-form-group>
								</b-col>
								<b-col cols="5">
									<b-form-group label="Libellé" class="mb-1">
										<b-input v-model="sp_new_libelle" size="sm" placeholder="ex: Date de début" trim></b-input>
									</b-form-group>
								</b-col>
								<b-col cols="2">
									<b-form-group label="Type" class="mb-1">
									<b-form-select v-model="sp_new_type" :options="sp_type_options" size="sm" @change="sp_type_user_set = true"></b-form-select>
								</b-form-group>
							</b-col>
						</b-row>
						<b-form-group v-if="sp_new_type === 'liste'" label="Options (une par ligne, ou valeur:libellé)" class="mb-1">
							<b-form-textarea v-model="sp_new_list_options" size="sm" rows="3" placeholder="Lundi
Mardi
Oui:Oui
Non:Non"></b-form-textarea>
						</b-form-group>
						<p v-if="sp_new_type === 'avance'" class="text-muted small mb-1">
							<i class="fas fa-info-circle mr-1"></i>Le paramètre sera créé comme Texte. Cliquez sur <i class="fas fa-edit"></i> après création pour configurer son type avancé.
						</p>
						<!-- Champ à remplacer : uniquement si pas un script -->
						<b-form-group v-if="!sp_is_script" label="Champ à remplacer" class="mb-1">
							<b-form-select
								v-if="sp_known_field_options.length > 1"
								v-model="sp_new_jsonpath"
								:options="[{ value: '', text: '— Sélectionner —' }, ...sp_known_field_options]"
								size="sm"
								class="mb-1"
								@change="sp_on_field_select"
							></b-form-select>
							<b-input
								v-if="sp_known_field_options.length <= 1 || sp_new_jsonpath === '__custom__'"
								v-model="sp_new_jsonpath_custom"
								size="sm" placeholder="$.champ" trim
							></b-input>
						</b-form-group>
						<p v-else class="text-muted small mb-1">
							Ce paramètre sera accessible via <code>treatment_params.{{ sp_new_name || 'nom' }}</code> dans les scripts.
						</p>
					</template>

						<div v-if="sp_error" class="text-danger small mb-1">{{ sp_error }}</div>
						<div class="d-flex" style="gap:6px">
							<b-button size="sm" variant="primary" @click="sp_submit">
								{{ sp_mode === 'link' ? 'Associer' : 'Créer' }}
							</b-button>
							<b-button size="sm" variant="link" @click="sp_close_form">Annuler</b-button>
						</div>
					</div>

				</div>
			</b-collapse>
		</div>

		<div v-show="c_project">
			<br />
			<p>Projet</p>
			<v-select
				:style="'max-width: ' + (size - 100) + 'px'"
				@input="update_project"
				v-model="project_id"
				:options="project_list"
				label="text"
				:reduce="(option) => option.value"></v-select>
			<b-alert v-if="project_is_archived" show variant="warning" class="mt-2 py-1 px-2" style="font-size:0.85em;">
				<i class="fas fa-exclamation-triangle mr-1"></i> Ce projet est archivé.
			</b-alert>

			<div v-if="treatment_params && treatment_params.length > 0" class="mt-3">
				<p class="font-weight-bold mb-2">Paramètres du scénario</p>
				<treatment_params :type_save="user_params_save" :type_save_default="user_params_save_default" :data="prev_data" :files="prev_files" :columns="prev_data.length > 0 ? Object.keys(prev_data[0]) : []" ref="treatment_params"></treatment_params>
			</div>
			<hr v-if="action === 'projet'" class="mt-3 mb-2" />
		</div>

		<div v-if="elements.length > 0 || action === 'rules'">
			<div v-if="elements_type == 'chatgpt'">
				<p>Requêtes préparées</p>
				<b-select  :options="elements" v-model="data.element"></b-select>
			</div>
			<div v-else>
				<p>Règles</p>
				<b-input-group>
					<b-input :list="'r' + data.uid" v-model="data.element" />
					<b-input-group-append v-if="_canUseLibrary">
						<b-button v-b-modal="'modal_rules_library_' + data.uid" variant="outline-secondary" title="Gérer la règle dans la bibliothèque">
							<i class="fas fa-book"></i>
						</b-button>
					</b-input-group-append>
				</b-input-group>
				<datalist :id="'r' + data.uid">
					<option v-for="(element) in elements" :key="element.value">{{ element.text }}</option>
				</datalist>
			</div>
			<br /><br />
		</div>

		<b-modal
			v-if="_canUseLibrary && action === 'rules'"
			:id="'modal_rules_library_' + data.uid"
			size="xl"
			title="Bibliothèque - Règles"
			ok-title="Utiliser cette règle"
			cancel-title="Fermer"
			no-close-on-backdrop
			no-close-on-esc
			@ok="use_library_rule"
			@shown="on_library_rule_modal_shown"
		>
			<LibraryEditor ref="library_rules" _type="rules" :minimal="false" :prev_data="prev_data" :hide_treatment="true"></LibraryEditor>
		</b-modal>

    <div v-if="ready && action.toLowerCase() === 'fonctions excel'">
      <FonctionsExcel
	  	:size="size"
        ref="fonctionsExcelComponent"
        :editor-ref="editor"
        :initial-value="editor.getValue()"
        :available-columns="availableColumns"
        :prev-data="prev_data"
        @TestFunctions="() => test()"
        >
      </FonctionsExcel>

    </div>

    <div v-if="ready && action.toLowerCase() === 'google_sheets'">
      <HelperExportGsheets
        ref="exportGSheetsComponent"
        :editor-ref="editor"
        :initial-value="editor.getValue()"
        :available-columns="availableColumns"
        :prev-data="prev_data">

      </HelperExportGsheets>
    </div>

		<div v-if="action.toLowerCase() === 'api'">
			<api_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position" />
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'mapping colonnes'">
			<mapping_colonnes_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position" />
		</div>

		<div v-if="action.toLowerCase() === 'mapping'">
			<!-- 				
				@regenerate-columns="() => regenerateMappingColumns()"
				@mapping-updated="(newMapping) => modifyMapping(newMapping)"
			-->
			<mapping
				ref="editor"
				:data="prev_data"
				:result_data="tabulator_data"
				:client="client"
				 />
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'scraping'">
			<scraping
				ref="editor"
				:data="prev_data"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:available-columns="availableColumns"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'correspondance_v2'">
			<correspondance
				ref="editor"
				:data="prev_data"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'chatgpt_v2' || action.toLowerCase() === 'perplexity'">
			<chatgpt
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:user_params_config="user_params_config"
				:user_params_test="user_params_test"
				:project_uid="project_uid"
				:step_position="step_position"
				:service="action.toLowerCase() === 'perplexity' ? 'perplexity' : 'chatgpt'"
				/>
			<br />
		</div>


		<div v-if="action.toLowerCase() === 'chatgpt_train'">
			<chatgpt_train
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:user_params_config="user_params_config"
				:user_params_test="user_params_test"
				:project_uid="project_uid"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'firecrawl'">
			<firecrawl
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'base de données'">
			<base_de_donnees
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:tables="tables"
				:db_schema="db_schema"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'projet'">
			<projet_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				:project_id="project_id"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'file'">
			<file_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'fusionner lignes'">
			<fusionner_lignes
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'siren'">
			<siren_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'html'">
			<html_step
				ref="editor"
				:data="prev_data"
				:client="client"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'share_document_v2'">
			<share_document_v2
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'split_json'">
			<split_json_step
				ref="editor"
				:data="prev_data"
				:available_columns="availableColumns"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'mail'">
			<mail_step
				ref="editor"
				:data="prev_data"
				:available_columns="availableColumns"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'fonction'">
			<fonction
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:step_position="step_position"
				:scenario_uid="scenario_uid"
				:step_uid="data.uid"
				@parameter-changed="change_emit()"
				@codegen-test-mode="$emit('codegen-test-mode', $event)"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'linkedin'">
			<linkedin
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'xlsx'">
			<xlsx
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'splashsync'">
			<splashsync
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'prestashop'">
			<splashsync
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:result_data="tabulator_data"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

        <div v-if="action.toLowerCase() === 'airtable'">
            <helper-airtable
                ref="editor"
                :available-columns="availableColumns"
                :prev-data="prev_data"
                 />
        </div>

		<div v-if="action.toLowerCase() === 'agenda'">
			<agenda_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				:project_list="project_list"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'translate'">
			<translate_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'send_notifications'">
			<send_notifications_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'supprimer lignes'">
			<supprimer_lignes_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'split'">
			<split_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'sort'">
			<sort_step
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-if="action.toLowerCase() === 'chercher et classer'">
			<chercher_et_classer
				ref="editor"
				:data="prev_data"
				:files="prev_files"
				:client="client"
				:size="size"
				:step_position="step_position"
				/>
			<br />
		</div>

		<div v-show="showJSONEditor" class="flex relative z-0" v-if="c_parameters">
			<div class="mr-2" :class="!showJSONParams ? 'opacity-25' : ''">
				Paramètres JSON:
			</div>
			<b-form-checkbox switch v-model="showJSONParams"> </b-form-checkbox>
		</div>

		<div v-show="c_parameters && showJSONEditor">
			<!-- <br /> -->
			<div :id="'jsoneditor-' + action_id"></div>
		</div>

		<div v-show="c_test">
			<div v-if="test_line_max">
				{{test_line_nb}} / {{ test_line_max }} lignes
				<b-button v-if="!stop_test" variant="primary" @click="stopTest">Stop</b-button>
				<div v-else >Le test va être stoppé.</div>
				<div>
					<br />
				</div>
			</div>
			<div v-else>
				<b-button variant="primary" @click="test">Test</b-button>&nbsp;
				<span v-if="test_line"><b-button variant="primary" @click="testByLine(false)">Test ligne à ligne</b-button>&nbsp;&nbsp;</span>
				<span v-if="test_line && lines_nb > 1"><b-button variant="primary" @click="testByLine(true)">Test par lots de {{ lines_nb }} lignes</b-button>&nbsp;&nbsp;</span>
				<b-button v-if="!workflow" variant="primary" @click="test(true)"
					>Test depuis la première étape</b-button
				>
				<b-button v-if="checkpoint && !simple_mode" variant="warning" @click="$emit('test_from_checkpoint', id)" class="ml-1"
					>Tester depuis le checkpoint</b-button
				>
				<div v-if="stop_test">
					Le test a été stoppé à la ligne {{ test_line_nb }}
				</div>
				<div v-else>
					<br />
				</div>
			</div>
			<p v-if="start_time >= 0">
				<b-progress :max="3">
					<b-progress-bar
						v-if="dowload_time >= -1"
						:variant="error ? 'danger' : 'info'"
						value="1"
						:animated="dowload_time >= 0 ? false : true"
						><span
							>Envoi
							{{
								dowload_time >= 0
									? " : " +
									  	(parseInt((dowload_time - start_time) / 1000) > 0 ? parseInt((dowload_time - start_time) / 1000) : 0) +
									  " s"
									: " en cours"
							}}</span
						></b-progress-bar
					>
					<b-progress-bar
						v-if="treatment_time >= -1"
						:variant="error ? 'danger' : 'success'"
						value="1"
						:animated="treatment_time >= 0 ? false : true"
						><span
							>Traitement
							{{
								treatment_time >= 0
									? " : " +
									  (parseInt((treatment_time - dowload_time) / 1000) > 0 ? parseInt((treatment_time - dowload_time) / 1000) : 0) +
									  " s"
									: " en cours"
							}}</span
						></b-progress-bar
					>
					<b-progress-bar
						v-if="upload_time >= -1"
						:variant="error ? 'danger' : 'info'"
						value="1"
						:animated="upload_time >= 0 ? false : true"
						><span
							>Reception
							{{
								upload_time >= 0
									? " : " +
									  	(parseInt((upload_time - treatment_time) / 1000) > 0 ? parseInt((upload_time - treatment_time) / 1000) : 0) +
									  " s"
									: " en cours"
							}}</span
						></b-progress-bar
					>
				</b-progress>
				<span v-if="error">{{ error }}</span>
			</p>
		</div>

		<div v-show="c_test">
			<edit_tabulator
				:select_mode="true"
				:style="'max-width: ' + (size - 100) + 'px'"
				@data="event_data"
				:extern_file="false"
				v-show="
					tabulator_data.length > 0 &&
					Object.keys(tabulator_data[0]).length > 0
				"
				ref="result_test"
				:filename="name_file || 'data.csv'"
				@filename_changed="name_file = $event; $emit('name_file_changed', $event)"
				:black_white_lists_edit="(data.parameters && data.parameters.black_white_lists_edit) ? true : false"
				:columns_type="columns_type"></edit_tabulator>
			<div v-show="option_make_list && tabulator_data.length > 0">
				<br />
				<b-button variant="primary" @click="makeList"
					>Faire une liste</b-button
				>
			</div>
			<div v-if="pdf_buffer">
				<span @click="currentPage--" v-if="currentPage > 1">&lt; </span
				>{{ currentPage }} / {{ pageCount }}
				<span @click="currentPage++" v-if="currentPage < pageCount">
					&gt;</span
				>
				<pdf
					style="border: solid"
					:page="currentPage"
					@num-pages="pageCount = $event"
					v-bind:src="pdf_buffer" />
			</div>
			<div v-if="html_viewver">
				<div v-html="html_viewver"></div>
			</div>
			<div v-if="results_files.length > 0 || urls.length > 0">
				<!-- <div><span v-if="!pdf_buffer">Autres </span>fichiers : </div> -->
				<b-button
					variant="link"
					v-for="file in results_files"
					:key="file.name"
					@click="dowload_file(file)"
					>{{ file.name }}</b-button
				>
				<span v-for="url in urls" :key="url.name">
					<b-button
						variant="link"
						@click="dowload_url(url, true)"
						>{{ url.name }}</b-button
					>
					<b-button
						variant="link"
						style="padding: 1px"
						title="Télécharger directement"
						@click="download_url_direct(url)"
						><i class="fas fa-download"></i></b-button
					>
				</span>
				<viewFile
					:showFileName="
						results_files.length + urls.length > 1 ? true : false
					"
					:style="'max-width: ' + (size - 100) + 'px'"
					ref="view_file"
					v-if="view_file"></viewFile>
			</div>
			<div v-if="errors.length > 0" style="margin-top:12px">
				<h4 style="margin-bottom:4px">Erreurs
					<i class="fas fa-info-circle text-muted"
					   v-b-tooltip.hover
					   :title="(errors.length > 100 ? '100 premières sur ' + errors.length : errors.length) + ' ligne' + (errors.length > 1 ? 's' : '') + ', tronquées à 10 000 caractères.'"
					   style="font-size:0.75em; vertical-align:middle; margin-left:4px; cursor:default"></i>
				</h4>
				<pre :style="'max-width: ' + (size - 100) + 'px; white-space: pre-wrap; font-size:0.85em; max-height:400px; overflow-y:auto; margin:0; padding:8px; background:#1e1e1e; color:#d4d4d4; border-radius:4px'">{{ errors.slice(0, 100).join('\n') }}</pre>
			</div>

			<div v-if="script_logs.length > 0 && action.toLowerCase() === 'fonction'" style="margin-top:12px">
				<b-button variant="link" class="p-0" v-b-toggle="'logs-' + action_id">
					Logs du script
					<i class="fas fa-info-circle text-muted"
					   v-b-tooltip.hover
					   :title="script_logs.length + ' ligne' + (script_logs.length > 1 ? 's' : '') + (script_logs_total > script_logs.length ? ' sur ' + script_logs_total + ' produites' : '') + ', limitées à 500 lignes × 1000 caractères.'"
					   style="font-size:0.75em; vertical-align:middle; margin-left:4px; cursor:default"></i>
				</b-button>
				<b-collapse :id="'logs-' + action_id">
					<pre :style="'max-width: ' + (size - 100) + 'px; white-space: pre-wrap; font-size:0.8em; max-height:400px; overflow-y:auto; background:#1e1e1e; color:#d4d4d4; padding:8px; border-radius:4px; margin:4px 0 0 0'">{{ script_logs.join('\n') }}</pre>
				</b-collapse>
			</div>
		</div>

		<div
			v-observe-visibility="() => redrawPrevDataTabulator(true)"
			v-show="
				prev_data.length > 0 ||
				prev_files.length > 0 ||
				prev_urls.length > 0
			">
			<h3>Données précédentes</h3>
			<edit_tabulator
				:select_mode="true"
				:style="'max-width: ' + (size - 100) + 'px'"
				v-show="prev_data.length > 0"
				:extern_file="false"
				ref="prev_data_tabulator"
				:filename="prev_name_file || 'data.csv'"
				:black_white_lists_edit="(data.parameters && data.parameters.black_white_lists_edit_prev) ? true : false"
				:columns_type="columns_type"></edit_tabulator>
			<div v-if="prev_files.length > 0 || prev_urls.length > 0">
				<!-- <div>Autres fichiers : </div> -->
				<b-button
					variant="link"
					v-for="file in prev_files"
					:key="file.name"
					@click="dowload_file(file)"
					>{{ file.name }}</b-button
				>
				<b-button
					variant="link"
					v-for="url in prev_urls"
					:key="url.name"
					@click="dowload_url(url)"
					>{{ url.name }}</b-button
				>
				<viewFile
					:showFileName="
						prev_files.length + prev_urls.length > 1 ? true : false
					"
					:style="'max-width: ' + (size - 100) + 'px'"
					ref="view_file_prev"
					v-if="view_file_prev"></viewFile>
			</div>
		</div>
	</div>
</template>

<script>
	var clone = require("clone");

	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	// import { Autocomplete } from ''
	import Autocomplete from "@trevoreyre/autocomplete-js";

	import { JSONEditor } from "@json-editor/json-editor";

	import uniqueId from "lodash.uniqueid";
	import viewFile from "./viewFile.vue";
	import * as json2csv from "json2csv";
	import draggable from "vuedraggable";
	import { uuid } from "vue-uuid";
	import alasql from "alasql";
	import pdf from "vue-pdf";
	import $ from "jquery";

	import store from "../store";
	import element from "../services/element.js";
	import library from "../services/library.js";
	import workers from "../services/workers.js";
	import LibraryEditor from "../views/Library.vue";
	import edit_tabulator from "./edit_tabulator.vue";
	import draggable_tree from "./draggable_tree.vue";
	import treatments from "../services/treatments.js";
	import treatment_params from "./treatment_params.vue"

	import VueCascaderSelect from "vue-cascader-select";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	import request_perso_overview from "./request_perso_overview.vue";

	// #region Import des schemas depuis schemas-JSON pour ne pas gonfler ce fichier

 	 import { schema_fonctions_excel } from "../schemas-JSON/fonctions_excel.js";
	import requestSchema from "../schemas-JSON/request.json";
	import scrapingSchema from "../schemas-JSON/scraping.json";

	import { schema_ftp } from "../schemas-JSON/ftp.js";
	import { schema_ocr } from "../schemas-JSON/ocr.js";
    import { schema_api } from "../schemas-JSON/api.js";
	import { schema_pdf } from "../schemas-JSON/pdf.js";
	import { schema_zip } from "../schemas-JSON/zip.js";
	import { schema_free } from "../schemas-JSON/free.js";
	import { schema_xlsx } from "../schemas-JSON/xlsx.js";
	import { schema_abby } from "../schemas-JSON/abby.js";
	import { schema_docx } from "../schemas-JSON/docx.js";
	import { schema_mail } from "../schemas-JSON/mail.js";
	import { schema_html } from "../schemas-JSON/html.js";
	import { schema_group } from "../schemas-JSON/group.js";
	import { schema_insee } from "../schemas-JSON/insee.js";
	import { schema_siren } from "../schemas-JSON/siren.js";
	import { schema_projet } from "../schemas-JSON/projet.js";
	import projet_step from "./steps/projet.vue";
	import { schema_vision } from "../schemas-JSON/vision.js";
	import { schema_library } from "../schemas-JSON/library.js";
	import { schema_chatgpt } from "../schemas-JSON/chatgpt.js";
	import { schema_sequence } from "../schemas-JSON/sequence.js";
	import { schema_fonction } from "../schemas-JSON/fonction.js";
	import { schema_nettoyage } from "../schemas-JSON/nettoyage.js";
	import { schema_textrazor } from "../schemas-JSON/textrazor.js";
	import { schema_prediction } from "../schemas-JSON/prediction.js";
	import { schema_hit_parade } from "../schemas-JSON/hit_parade.js";
	import { schema_split_zone } from "../schemas-JSON/split_zone.js";
	import { schema_conversion } from "../schemas-JSON/conversion.js";
	import { schema_split_json } from "../schemas-JSON/split_json.js";
	import { schema_deux_points } from "../schemas-JSON/deux_points.js";
	import { schema_referentiel } from "../schemas-JSON/referentiel.js";
	import { schema_pdf_extract } from "../schemas-JSON/pdf_extract.js";
	import { schema_zone_extract } from "../schemas-JSON/zone_extract.js";
	import { schema_user_details } from "../schemas-JSON/user_details.js";	
	import { schema_chatgpt_train } from "../schemas-JSON/chatgpt_train.js";
	import { schema_magick_convert } from "../schemas-JSON/magick_convert.js";
	import { schema_share_document } from "../schemas-JSON/share_document.js";
	import { schema_correspondance } from "../schemas-JSON/correspondance.js";
	import { schema_base_de_donnees } from "../schemas-JSON/base_de_donnees.js";
	import { schema_zone_final_extract } from "../schemas-JSON/zone_final_extract.js";
	import { schema_blacklist_whitelist } from "../schemas-JSON/blacklist_whitelist.js";
	import { schema_chercher_et_remplacer } from "../schemas-JSON/chercher_et_remplacer.js";
	import { schema_operations_sur_colonnes } from "../schemas-JSON/operations_sur_colonnes.js";
	import { schema_mapping_colonnes_fichier_cible } from "../schemas-JSON/mapping_colonnes_fichier_cible.js";

	// #endregion

	import helper_export_Gsheets from "./Project_v2/helper_export_gsheets.vue"
	import fonctions_excel from "./Project_v2/fonctions_excel.vue";
	import step_credentials_button from "./StepCredentialsButton.vue";
	import correspondance from "./steps/correspondance.vue";
	import chatgpt_train from "./steps/chatgpt_train.vue";
    import helper_airtable from "./helper_airtable.vue";
	import splashsync from "./steps/splashsync.vue";
	import firecrawl from "./steps/firecrawl.vue";
	import base_de_donnees from "./steps/base_de_donnees.vue";
	import siren_step from "./steps/siren.vue";
	import share_document_v2 from "./steps/share_document_v2.vue";
	import html_step from "./steps/html_step.vue";
	import file_step from "./steps/file.vue";
	import fusionner_lignes from "./steps/fusionner_lignes.vue";
	import chercher_et_classer from "./steps/chercher_et_classer.vue";
	import sort_step from "./steps/sort.vue";
	import split_step from "./steps/split.vue";
	import supprimer_lignes_step from "./steps/supprimer_lignes.vue";
	import send_notifications_step from "./steps/send_notifications.vue";
	import translate_step from "./steps/translate.vue";
	import agenda_step from "./steps/agenda.vue";
	import mapping_colonnes_step from "./steps/mapping_colonnes.vue";
	import api_step from "./steps/api.vue";
	import fonction from "./steps/fonction.vue";
	import split_json_step from "./steps/split_json.vue";
	import mail_step from "./steps/mail.vue";
	import linkedin from "./steps/linkedin.vue";
	import scraping from "./steps/scraping.vue";
	import chatgpt from "./steps/chatgpt.vue";
    import helper_n8n from "./helper_n8n.vue";
	import xlsx from "./steps/xlsx.vue";
	import mapping from "./mapping.vue";

	import { ActionList, ActionComment, ActionListV2 } from "../utils/liste_actions.js";
	import { getKnownFields, isScriptAction } from "../config/treatment_params_fields.js";
	import { getStepCredentialRequirements } from "../config/step_credentials_fields.js";

	export default {
		name: "step",
		components: {
			pdf,
			draggable,
			edit_tabulator,
			"draggable-tree": draggable_tree,
			"vue-cascader-select": VueCascaderSelect,
			"request-perso-overview": request_perso_overview,
            "helper-airtable": helper_airtable,
            "helper-n8n": helper_n8n,
			"HelperExportGsheets": helper_export_Gsheets,
			"FonctionsExcel": fonctions_excel,
			viewFile: viewFile,
			mapping,
			correspondance,
			treatment_params,
			chatgpt,
			scraping,
			firecrawl,
			step_credentials_button,
			siren_step,
			share_document_v2,
			html_step,
			file_step,
			fusionner_lignes,
			chercher_et_classer,
			sort_step,
			split_step,
			supprimer_lignes_step,
			send_notifications_step,
			translate_step,
			agenda_step,
			mapping_colonnes_step,
			api_step,
			fonction,
			split_json_step,
			mail_step,
			linkedin,
			xlsx,
			chatgpt_train,
			splashsync,
			base_de_donnees,
			projet_step,
			FadeLoader,
			LibraryEditor
		},
		props: {
			action_preset: {
				type: Object,
				default: null,
			},
			action_id: {
				default: uniqueId(""),
			},
			cible_data: {
				default: () => [],
			},
			columns: {
				default: () => [{ colonne: "", type: "texte" }],
			},
			id: {
				default: uniqueId(""),
			},
			prev_data: {
				default: () => [],
			},
			prev_files: {
				default: () => [],
			},
			prev_urls: {
				default: () => [],
			},
			load_data: {
				default: null,
			},
			projects: {
				default: () => [],
			},
			projects_archive: {
				default: () => [],
			},
			tables: {
				default: () => [],
			},
			db_schema: {
				default: () => ({}),
			},
			size: {
				default: 0,
			},
			client: {
				default: null,
			},
			list_words: {
				default: () => [],
			},
			columns_type: {
				default: () => {}
			},
			user_params_config: {
				default: ""
			},
			user_params_test: {
				default: false
			},
			project_uid: {
				default: ""
			},
			step_position: {
				default: 0
			},
			workflow: {
				default: false
			},
			lines_mode: {
				default: false
			},
			lines_mode: {
				default: false
			},
			lines_nb: {
				default: 1
			},
			readonly_action: {
				type: Boolean,
				default: false
			},
			show_user_params_editor: {
				type: Boolean,
				default: false
			},
			/** Liste globale des treatment_params du scénario (format v2). Passée par Project_v2. */
			scenario_params: {
				type: Array,
				default: () => []
			},
			/** Mode simple : masque les options avancées (paramètres du scénario, etc.). */
			simple_mode: {
				type: Boolean,
				default: false
			},
			/** Repère de test actif pour cette étape (non null si cette étape est après le repère). */
			checkpoint: {
				default: null,
			},
			/** Liste des étapes du scénario pour la sélection des sources. Chaque item : {uid, position, label} */
			steps_list: {
				type: Array,
				default: () => []
			},
			/** Uid du scénario courant (Project_v2.this.uid), pour la persistance S3 des
			 * conversations IA de génération de code (codegen chats, cf CodeGenerator.vue
			 * et TODO_CODEGEN_CHAT.md section 4). Peut être vide tant que le scénario n'a
			 * jamais été enregistré. */
			scenario_uid: {
				type: String,
				default: ""
			},
		},
		data() {
			return {
				ready: true,
				editor: null,

				config: {},
				data: {
					uid: this.$uuid.v4()
				},
				description: "",
				comment: "",
				long_description: "",
				action: "",
				actionLabel: "Nouvelle étape",
				ActionComment: ActionComment,

				test_line: false,
				c_conditions: false,
				c_tree: false,
				c_project: false,
				project: {},
				project_list: [],
				project_id: "",
				project_is_archived: false,
				c_parameters: false,
				c_tabulator: false,
				c_test: false,
				result: null,
				errors: [],
				script_logs: [],
				script_logs_total: 0,

				tabulator_data: [],
				statut: "",
				collapse: false,

				option_delete: false,
				option_make_list: false,
				keep_start_data: false,
				treatment: false,
				results_files: [],
				name_file: "",
					prev_name_file: "",
				start_time: -2,
				dowload_time: -2,
				treatment_time: -2,
				upload_time: -2,

				menu: [],

				json_step: {},

				pdf_buffer: "",
				currentPage: 1,
				pageCount: 0,

				html_viewver: "",
				error: false,

				source_data: "",
				source_data_ids: [],
				file_result: false,

				servicesPerso: [],
				requestsPerso: {},
				requestsPersoLabels: [],
				currentRequest: null,

				availableColumns: [],

				usesPrevColumnNames: false,
				columnDropdownOrderPref: "default",
				showJSONParams: false,

				urls: [],
				view_file: false,
				view_file_prev: false,

				prevDataRedrawn: false,

				showJSONEditor: true,
				
				user_params: [],
				collapse_user_params: false,
				editor_user_params: null,

				elements: [],
				elements_type: "",

				treatment_params: [],
				user_params_save: "",
				user_params_save_default: "",

				action_components: [
					"mapping", 
					"correspondance_v2", 
					"chatgpt_v2", 
					"perplexity", 
					"scraping", 
					"firecrawl",
					"siren",
					"fonction", 
					"airtable", 
					"chatgpt_train",
					"linkedin",
					"xlsx",
					"splashsync",
                                        "prestashop",
					"share_document_v2",
					"html",
"split_json",
				"mail",
				"base de données",
				"projet",
					"file",
					"fusionner lignes",
					"chercher et classer",
					"sort",
					"split",
					"supprimer lignes",
					"send_notifications",
					"translate",
					"agenda",
					"mapping colonnes",
					"api"
				],

				treatment_params_elements: [],

				collapse_scenario_params: false,
				// Form inline pour créer/associer un param depuis l'étape
				sp_show_form: false,
				sp_mode: "link",   // 'link' | 'create'
				sp_link_name: null,
				sp_new_name: "",
				sp_new_libelle: "",
				sp_new_jsonpath: "",
				sp_new_jsonpath_custom: "",
				sp_new_param_name: "",
				sp_new_type: null,
				sp_type_user_set: false,
					sp_new_list_options: "",

				// Options communes aux composants Vue (non JSON editor)
				step_strict: false,
				step_cut_start: false,
				step_cut_end: false,

				test_line_max: 0,
				test_line_nb: 0,
				stop_test: false,
				lines: false,
				spinner: false,

				custom_prompt: "",
				show_custom_prompt: false,
			};
		},
		created: function () {
			// JSONEditor.plugins.selectize.enable = true;
			// console.log("Enabled selectize");
		},
		computed: {
			_canGenerateIa() {
				const rules = store.state.user ? store.state.user.rules : undefined;
				if (rules === null) return true;
				return !!(rules && rules.generate_ia);
			},
			_canUseLibrary() {
				const user = store.state.user;
				return !!(user && (user.rules == null || user.rules.library));
			},
			/** Vrai si l'utilisateur a le droit de gérer les clés de sécurité (même droit que la page Credentials). */
			_canManageCredentials() {
				const user = store.state.user;
				return !!(user && (user.rules == null || user.rules.credentials));
			},
			/** Credentials requises par le type d'étape courant (registre step_credentials_fields.js). */
			_stepCredentialRequirements() {
				return getStepCredentialRequirements(this.action);
			},
			/**
			 * Pour les étapes "api" et "fonction" (script personnalisé), le comportement est différent :
			 * on affiche toutes les clés existantes (pas seulement celles du registre) et on permet
			 * d'en ajouter de nouvelles arbitrairement, car ces étapes peuvent référencer n'importe
			 * quelle credential par son nom.
			 */
			_stepCredentialsFreeform() {
				return this.action === "api" || isScriptAction(this.action || "");
			},
			isLegacy() {
				const allV2Values = ActionListV2().flatMap(t => t.actions.map(a => a.value));
				return this.action && !allV2Values.includes(this.action);
			},
			actionLabelV2() {
				for (const theme of ActionListV2()) {
					const found = theme.actions.find(a => a.value === this.action);
					if (found) return found.label;
				}
				return this.actionLabel;
			},
			/** Paramètres globaux qui ciblent cette étape (format v2 uniquement). */
			params_targeting_this_step() {
				var uid = this.data && this.data.uid;
				if (!uid) return [];
				return (this.scenario_params || []).filter(p =>
					Array.isArray(p.targets) && p.targets.some(t => t.step_uid === uid)
				);
			},
			/** Noms déjà utilisés dans scenario_params (pour validation unicité). */
			sp_existing_names() {
				return new Set((this.scenario_params || []).map(p => p.name));
			},
			/** Options pour le sélecteur "associer un paramètre existant". */
			sp_link_options() {
				var uid = this.data && this.data.uid;
				// Proposer les params v2 qui ne ciblent pas encore cette étape
				return (this.scenario_params || [])
					.filter(p => Array.isArray(p.targets) && !p.targets.some(t => t.step_uid === uid))
					.map(p => ({ value: p.name, text: p.libelle || p.name }));
			},
			/** Champs connus pour cette action (pour le sélecteur jsonpath). */
			sp_known_field_options() {
				var fields = getKnownFields(this.action || "");
				if (!fields || fields.length === 0) return [];
				var opts = fields.map(f => ({ value: f.jsonpath, text: f.label }));
				opts.push({ value: "__custom__", text: "— JSONPath libre —" });
				return opts;
			},
			/** Options de type pour le formulaire inline. */
				sp_type_options() {
					return [
						{ value: "texte",    text: "Texte" },
						{ value: "date",     text: "Date" },
						{ value: "nombre",   text: "Nombre" },
						{ value: "textarea", text: "Texte long" },
						{ value: "liste",    text: "Liste déroulante" },
						{ value: "avance",   text: "Avancé…" },
					];
				},
			/** true si c'est une action de script personnalisé. */
			sp_is_script() {
				return isScriptAction(this.action || "");
			},
		},
		methods: {
			on_library_rule_modal_shown() {
				if (this.data.element && this.$refs.library_rules)
					this.$refs.library_rules.load_name = this.data.element;
			},
			async use_library_rule(bvModalEvt) {
				if (!this.$refs.library_rules)
					return;

				// on empêche la fermeture immédiate : on gère la fermeture nous même une fois l'enregistrement terminé
				if (bvModalEvt)
					bvModalEvt.preventDefault();

				if (!this.$refs.library_rules.name) {
					this.$notify({
						group: "info",
						title: "Nom manquant",
						text: "Merci de donner un nom à la règle avant de l'utiliser.",
						type: "error"
					});
					return;
				}

				if (!this.$refs.library_rules.version)
					this.$refs.library_rules.version = "1";

				this.data.element = this.$refs.library_rules.name;
				if (!this.data.parameters) this.data.parameters = {};
				this.data.parameters.element = this.data.element;

				try
				{
					await this.$refs.library_rules.save_db();
				}
				catch (err)
				{
					console.error(err);
					this.$notify({
						group: "info",
						title: "Erreur",
						text: "La règle n'a pas pu être enregistrée.",
						type: "error"
					});
					return;
				}

				var elements = await library.getby_production('rules');
				elements = elements.element;

				this.elements = [];
				for (var i = 0; i < elements.length; i++) {
					this.elements.push({
						text: elements[i].name,
						value: elements[i].name
					});
				}

				this.$bvModal.hide('modal_rules_library_' + this.data.uid);
			},
			async generate_description()
			{
				this.spinner = true;

				var parameters = this.data.parameters;
				if (this.action_components.includes(this.action))
				{
					parameters = this.$refs.editor.save();
				}

				if (this.$refs.treatment_params)
					parameters.params = this.$refs.treatment_params.get_obj();

    			var request =
`Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description de ce que fait l’étape (effet sur les données), pas une explication des paramètres.

Contraintes:
- Interdit: lister les paramètres, expliquer le code ligne par ligne, citer des noms de variables internes.
- Autorisé: mentionner colonnes clés modifiées/créées/supprimées + critère (conditions) si présent.
- Si c’est un filtre: utilise “Conserve…” ou “Supprime…”.
- Si c’est une transformation JS: utilise “Transforme…” et cite les sorties principales.

`
				if (this.custom_prompt && this.custom_prompt.trim())
					request = this.custom_prompt.trim() + "\n\n";

				request += "Nom de l'étape : " + this.action + "\n";

				if (this.comment)
					request += "Commentaire : " + this.comment + "\n";

				if (ActionComment[this.action])
					request += "Description de l'étape : " + ActionComment[this.action] + "\n";

				var sql_rules = this.getRules();
				if (sql_rules)
					request += "Conditions : " + sql_rules + "\n";

				request += "Paramètres : " + JSON.stringify(parameters);

				var formData = new FormData();
				formData.append("action", "saas_back-openai");
				formData.append("parameters", JSON.stringify({
					"config": "documentation etape",
					"template": false,
					"content": "request",
					"column_result": "result",
					"column_error": "error",
				}));

				var data = [{request: request }];

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				formData.append(files[0].name, files[0], "data.csv");

				var data = await workers.test(formData);
				var csv_data = await treatments.getFileAlyx(
					data.data.files[0].url,
					false,
					false
				);
				var data  = this.$papa.parse(csv_data, {
					header: true,
				});
				data = data.data;

				this.long_description = data[0].result;

				this.spinner = false;
			},
toggle_custom_prompt()
				{
					if (this.show_custom_prompt) {
						this.show_custom_prompt = false;
						return;
					}
					if (!this.custom_prompt)
						this.prefill_custom_prompt();
					this.show_custom_prompt = true;
				},
				prefill_custom_prompt()
			{
				var parameters = this.data.parameters;
				if (this.action_components.includes(this.action))
					parameters = this.$refs.editor.save();
				if (this.$refs.treatment_params)
					parameters.params = this.$refs.treatment_params.get_obj();

				var request = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description de ce que fait l'étape (effet sur les données), pas une explication des paramètres.

Contraintes:
- Interdit: lister les paramètres, expliquer le code ligne par ligne, citer des noms de variables internes.
- Autorisé: mentionner colonnes clés modifiées/créées/supprimées + critère (conditions) si présent.
- Si c'est un filtre: utilise "Conserve…" ou "Supprime…".
- Si c'est une transformation JS: utilise "Transforme…" et cite les sorties principales.

`;
				request += "Nom de l'étape : " + this.action + "\n";
				if (this.comment)
					request += "Commentaire : " + this.comment + "\n";
				if (ActionComment[this.action])
					request += "Description de l'étape : " + ActionComment[this.action] + "\n";
				var sql_rules = this.getRules();
				if (sql_rules)
					request += "Conditions : " + sql_rules + "\n";
				this.custom_prompt = `Tu es rédacteur de documentation produit pour un outil de scénarios de traitement de données.

But:
Écrire une description de ce que fait l'étape (effet sur les données), pas une explication des paramètres.

Contraintes:
- Interdit: lister les paramètres, expliquer le code ligne par ligne, citer des noms de variables internes.
- Autorisé: mentionner colonnes clés modifiées/créées/supprimées + critère (conditions) si présent.
- Si c'est un filtre: utilise "Conserve…" ou "Supprime…".
- Si c'est une transformation JS: utilise "Transforme…" et cite les sorties principales.`;
				this.show_custom_prompt = true;
			},
			stopTest()
			{
				this.$emit("stop_test");
				this.stop_test = true;
			},
			set_test_line(test_line_nb, test_line_max)
			{
				if (test_line_nb > 0)
					this.test_line_nb = test_line_nb;
				this.test_line_max = test_line_max;
			},
			getUid()
			{
				return this.data.uid;
			},
            invertShowJSONEditor: function () {
                this.showJSONEditor = !this.showJSONEditor;
            },
            toggleShowJSONEditor(show) {
                this.showJSONEditor = show;
            },
			redrawPrevDataTabulator(redrawFromVisibility = false) {
				// if (redrawFromVisibility)
				//     this.prevDataRedrawn = redrawFromVisibility;

				//if (redrawFromVisibility && this.prevDataRedrawn) return;
				//	this.$refs.prev_data_tabulator.redraw(true);
			},
			redrawEditTabulator() {
				this.$refs.edit_tabulator.redraw(true);
				// this.$regs.prev_data_tabulator.redraw(true);
			},
			modifyRequest(newVal) {
				this.currentRequest = newVal;
				this.setJSONRequestParameters();
			},
			setJSONRequestParameters() {
                console.log("Setting JSON request parameters: ", this.currentRequest.parameters);

				// * mise à jour de data avec les infos de la requete
				// * on convertit notre requete en data acceptée par le schema API
				let requestParams = this.currentRequest.parameters;
				//console.log("Current config: ", this.data.parameters);
				let requestData = {
					unique: this.data.parameters.unique,
					column_result: this.data.parameters.column_result,
					column_error: this.data.parameters.column_error,
				};
				requestData.uri = requestParams.url;
				requestData.method = requestParams.verb.toLowerCase();
				requestData.sleep = requestParams.timeBetweenRequests;
				requestData.files = requestParams.formData.envoiFichiers;
				requestData.response_file =
					requestParams.formData.reponseFichiers;

				for (let propertyName in requestParams) {
					let val = requestParams[propertyName];

					// * si on a un tableau:
					if (Array.isArray(val)) {
						// * boucle dessus
						for (let i = 0; i < val.length; i++) {
							// * supprime les valeurs sans nom de paramètre
							if (val[i].parameter.length === 0) {
								// * remove property
								val.splice(i, 1);
								continue;
							}
						}
					}
				}

				// * on ajoute les valeurs des tableaux dans requestdata
				// * passé par référence, reqData est modifié avec nos valeurs, en fonction de si col est coché ou non
				let getRequestOptions = (
					currentReq,
					reqData,
					requestKey,
					valuesKey,
					columnsKey
				) => {
					currentReq[requestKey].forEach((elem) => {
						if (elem.col) {
							//console.log("Elem colonne: ", elem);
							if (!reqData.hasOwnProperty(columnsKey)) {
								reqData[columnsKey] = [];
							}
							reqData[columnsKey].push(elem.parameter);
						} else {
							// * add new key to object
							// * syntaxe pour ajouter un nouveau champ dans un objet
							reqData[valuesKey] = {
								...reqData[valuesKey],
								...{ [elem.parameter]: elem.value },
							};
						}
					});
				};

				getRequestOptions(
					requestParams,
					requestData,
					"queryParams",
					"qs_params",
					"qs"
				);
				getRequestOptions(
					requestParams,
					requestData,
					"headers",
					"headers_params",
					"headers"
				);
				getRequestOptions(
					requestParams,
					requestData,
					"body",
					"body_params",
					"body"
				);
				getRequestOptions(
					requestParams,
					requestData,
					"form",
					"form_params",
					"form"
				);

				//console.log("Request data final values ", requestData);

				this.update_data_parameters(requestData);
			},
			async getSelectedRequest(requestLabel) {
				let latestRequestInfo = (
					await element.getby_libelle(requestLabel, "appel_service")
				).element[0]; // la derniere version

				this.currentRequest = await element.load(
					requestLabel,
					latestRequestInfo.version,
					"appel_service"
				);

				// console.log("Current request structure: ", this.currentRequest);

				// * on re-set les parameters car entre temps les parameters ce sont mis mais la requete n'était pas récupérée
				// * aussi ça nous donne la data actuelle pour qu'on puisse la modifier

                // * on attend que le json editor soit chargé
                setTimeout(async () => {
                    await this.setParameters();

    				this.setJSONRequestParameters();
                }, 1);
			},
			async getMyServices() {
				// * on ajoute les services personnalisés dans la liste des services
				this.servicesPerso = (
					await element.getby_production("service")
				).element;

				let serviceDropdownOptions = this.menu.find(
					(menuOption) => menuOption.label === "Services"
				);

				await this.getMyRequests();

				this.servicesPerso.forEach((servicePerso) => {
					serviceDropdownOptions.options.push({
						label: servicePerso.libelle,
						value: servicePerso.libelle,
						options: this.requestsPerso[servicePerso.libelle],
						// todo pousser les sous-requêtes ici
					});
				});
			},
			async getMyRequests() {
				// * on load toutes les requetes puis on les répartit avec le nom du service comme clé
				let allRequests = (
					await element.getby_production("appel_service")
				).element;

				allRequests.forEach((request) => {
					// todo load la data de chaque requete
					let parsedDataDB = JSON.parse(request.data);

					if (
						this.requestsPerso[parsedDataDB.serviceLabel] ===
						undefined
					)
						this.requestsPerso[parsedDataDB.serviceLabel] = [];
					this.requestsPerso[parsedDataDB.serviceLabel].push({
						label: request.libelle,
						value: request.libelle,
					});

					this.requestsPersoLabels.push(request.libelle);
				});
			},
			toogleItem(index) {
				if (this.menu[index].children) {
					if (!this.menu[index].showSubMenu) {
						this.menu[index].showSubMenu = true;
					} else {
						this.menu[index].showSubMenu = false;
					}
				}
			},
			save() {
				var data = clone(this.data);
				// Ensure parameters is always a plain object (some steps can leave it as a string)
				// (l'action "api" peut légitimement avoir un tableau comme parameters — mode "plusieurs requêtes")
				if (!data.parameters || typeof data.parameters !== "object")
					data.parameters = {};
				else if (Array.isArray(data.parameters) && this.action.toLowerCase() !== "api")
					data.parameters = {};

				if (this.action_components.includes(this.action))
				{
				data.parameters = this.component_save();
				}

				if (this.$refs.treatment_params)
					data.parameters.params = this.$refs.treatment_params.get_obj();

				// Options d'exécution (gérées par la modale ⚙, valables pour toutes les étapes)
				if (this.step_strict) data.parameters.strict = true; else delete data.parameters.strict;
				if (this.step_cut_start) data.parameters.cut_start = true; else delete data.parameters.cut_start;
				if (this.step_cut_end) data.parameters.cut_end = true; else delete data.parameters.cut_end;

				delete data.file;
				delete data.file_blob;
				data.sql_rules = this.getRules();
				if (data.hasOwnProperty("element"))
				{
					if (!data.parameters || typeof data.parameters !== "object")
						data.parameters = {};
					else if (Array.isArray(data.parameters) && this.action.toLowerCase() !== "api")
						data.parameters = {};
					data.parameters.element = data.element;
				}				
				return {
					data: data,
					description: this.description,
					action: this.action.toLowerCase(),
					actionLabel: this.actionLabel,
					c_conditions: this.c_conditions,
					test_line: this.test_line,
					c_tree: this.c_tree,
					c_project: this.c_project,
					project_id: this.project_id,
					c_parameters: this.c_parameters,
					c_tabulator: this.c_tabulator,
					c_test: this.c_test,
					//result: this.result,
					//tabulator_data: this.tabulator_data,
					//prev_data: this.prev_data[0],
					tabulator2: this.$refs.edit_tabulator.get_data(),
					keep_start_data: this.keep_start_data,
					option_delete: this.option_delete,
					option_make_list: this.option_make_list,
					treatment: this.treatment,
					source_data: this._sync_source_data() || this.source_data || "",
					source_data_ids: this.source_data_ids || [],
					file_result: this.file_result || false,
					currentRequest: this.currentRequest,
					user_params: this.user_params,
					lines: this.lines,
					comment: this.comment,
					long_description: this.long_description
				};
			},
			get_comment() {
				return this.comment || "";
			},
			get_long_description() {
				return this.long_description || "";
			},
			get_action_label() {
				return this.actionLabel || this.action || "";
			},
			get_description() {
				return this.description || "";
			},
			async save_self()
			{
				var data = await this.save();
				data.step = this;
				return data;
			},
			async load(data) {
				console.log("load step");
				var self = this;
				this._loading = true;
				try {
					this.source_data = data.source_data || "";
					this.source_data_ids = data.source_data_ids || [];
					this.file_result = data.file_result || false
					this.data = data.data;
					if (!this.data.uid) 
						this.data.uid = this.$uuid.v4();
					this.description = data.description || "";
					this.long_description = data.long_description || "";
					this.comment = data.comment || "";
					this.action = data.action.toLowerCase();
					this.actionLabel = data.actionLabel || data.action;
					this.c_conditions = data.c_conditions;
					this.test_line = data.test_line || false;
					this.c_tree = data.c_tree;
					this.c_project = data.c_project;
					this.project_id = data.project_id;
					this.c_parameters = data.c_parameters;
					this.c_tabulator = data.c_tabulator;
					this.c_test = data.c_test;
					//this.result = data.result;
					//this.tabulator_data = data.tabulator_data,
					this.keep_start_data = data.keep_start_data;
					this.option_delete = data.option_delete;
					this.option_make_list = data.option_make_list;
					this.treatment = data.treatment;
					this.lines = data.lines || false;
					//console.log(JSON.stringify(this.user_params))
					if (this.data.tree) 
						this.$refs.tree.set(this.data.tree);

					if (this.project_id) 
						await this.update_project();

					try {
						//console.log("set action");
						//console.log(clone(this.data));
						await this.setAction();
						// * setAction() -> setParameters() est sérialisé par un mutex
						// * (_setParametersRunning/_setParametersPending, cf setParameters()).
						// * Si un autre watcher (ex: prev_data, deep) a déclenché setParameters()
						// * PENDANT que setAction() tournait, ce second appel est mis en attente
						// * puis relancé en fire-and-forget dans le "finally" de setParameters(),
						// * SANS être attendu par le `await this.setAction()` ci-dessus. Ce second
						// * passage recrée this.editor avec le schema par défaut (fonctions vide),
						// * et écrase silencieusement, un peu plus tard, les données qu'on va
						// * injecter juste en dessous - d'où la disparition des fonctions après un
						// * rechargement. On attend donc explicitement que le mutex soit totalement
						// * idle avant d'injecter data.data.parameters.
						let waitCycles = 0;
						while ((this._setParametersRunning || this._setParametersPending) && waitCycles < 50) {
							await new Promise((resolve) => setTimeout(resolve, 50));
							waitCycles++;
						}
						// * seulement set les rules du query builder si on a des rules:
						// console.log(data.data.rules);
						if (this.c_conditions && data.data.rules)
							$("#builder-" + this.action_id).queryBuilder(
								"setRules",
								data.data.rules
							);

						// * queryBuilder("setRules", ...) ci-dessus déclenche, de façon
						// * asynchrone (watcher Vue -> edit_tabulator emit("update") ->
						// * setParameters()), un NOUVEL appel à setParameters() qui détruit
						// * et recrée this.editor. Ce nouvel appel démarre lors du prochain
						// * flush de nextTick, donc APRES le wait-loop précédent (qui ne
						// * pouvait pas encore le détecter). Sans ce second wait, ce nouvel
						// * appel peut recréer this.editor avec le schema vide APRES le
						// * editor.setValue() ci-dessous et écraser silencieusement les
						// * fonctions rechargées - d'où le bug intermittent ("1 fois sur 10").
						// * On attend donc un tick Vue (pour laisser ce nouvel appel démarrer
						// * et poser le mutex) puis on reboucle dessus avant d'injecter data.
						await this.$nextTick();
						waitCycles = 0;
						while ((this._setParametersRunning || this._setParametersPending) && waitCycles < 50) {
							await new Promise((resolve) => setTimeout(resolve, 50));
							waitCycles++;
						}
					} catch (err) {
						console.log("Error creating step ", err);
					}

					this.user_params = data.user_params || [];

					//console.log(JSON.stringify(this.user_params))

					try {
						//console.log(clone(data.data.parameters))
						if (this.editor)
							self.editor.setValue(clone(data.data.parameters));

						// * setAction() (appelé plus haut) a déjà appelé editor_ready() sur le
						// * composant fonctions_excel, mais à ce moment-là l'editor venait d'être
						// * recréé avec le schema par défaut (fonctions vide) : data.data.parameters
						// * n'avait pas encore été injecté via setValue() ci-dessus. Sans ce second
						// * appel, currentFunctions reste bloqué à [] après un rechargement, alors
						// * que l'editor contient bien les fonctions sauvegardées.
						// * IMPORTANT : this.ready peut venir de passer à true dans setAction() juste
						// * avant (de manière synchrone dans ce flux async/await), mais Vue ne monte
						// * le composant (et ne peuple $refs.fonctionsExcelComponent) qu'au prochain
						// * tick. Sans $nextTick ici, ce check est donc silencieusement no-op (pas
						// * d'erreur) sur un premier chargement/rechargement de page, et
						// * currentFunctions reste vide. D'où le $nextTick ci-dessous.
						if (this.$refs.fonctionsExcelComponent) {
							self.$refs.fonctionsExcelComponent.editor_ready();
						} else {
							this.$nextTick(() => {
								if (self.$refs.fonctionsExcelComponent)
									self.$refs.fonctionsExcelComponent.editor_ready();
							});
						}
					} catch (err) {
						console.log("Error setting my editor values: ", err);
					}

					if (this.action_components.includes(this.action))
					{
					    this.$nextTick(() => {
							self.component_load(clone(data.data.parameters));
						});
					} else {
						// Extraire les flags pour les étapes JSON editor
						const p = data.data.parameters || {};
						self.step_strict = !!p.strict;
						self.step_cut_start = !!p.cut_start;
						self.step_cut_end = !!p.cut_end;
					}

					this.currentRequest = data.currentRequest;

					this.redrawEditTabulator();
				} catch (err) {
					console.log("step load : " + err);
					console.log(data);
				}

				if (this.$refs.edit_tabulator)
					this.$refs.edit_tabulator.set_data(data.tabulator2);

				//console.log("load")
				//console.log(data)
				//console.log(this.user_params)
				if (this.editor_user_params) this.editor_user_params.setValue(this.user_params);

				let findActionLabel = (startMenu, actionValue, fctRef) => {
					var finalLabel = "";

					startMenu.forEach((item) => {
						// * si on a trouvé à la boucle precedente, on return le resultat
						if (finalLabel.length > 0) return finalLabel;

						// * recursion
						if (item.hasOwnProperty("options")) {
							finalLabel = fctRef(
								item.options,
								actionValue,
								fctRef
							);
						} else if (item.value === actionValue) {
							// * on assigne le label voulu et on return
							finalLabel = item.label;
							return item.label;
						}
					});
					return finalLabel;
				};

				let labelSearchResult = findActionLabel(
					this.menu,
					this.action,
					findActionLabel
				);

				if (labelSearchResult.length > 0)
					this.actionLabel = labelSearchResult;
			},
			async update_data_parameters(data, project_id) {
				this.data.parameters = data;

				while (!this.ready) {
					await new Promise((resolve) =>
						setTimeout(resolve, 100)
					);
				}

				if (this.action == "zone_extract")
					this.editor.setValue({params: JSON.stringify(data, null, " ")});
				else if (this.action_components.includes(this.action))
					this.component_load(data);
				else 
					this.editor.setValue(data);

				if (project_id)
				{
					//console.log(project_id)
					this.project_id = project_id;
					await this.update_project();
				}
			},
			set_time(time) {
				if (time == "start") {
					this.start_time = new Date().getTime();
					this.dowload_time = -1;
					this.treatment_time = -2;
					this.upload_time = -2;
				} else if (time == "dowload") {
					this.dowload_time = new Date().getTime();
					this.treatment_time = -1;
				} else if (time == "treatment") {
					this.treatment_time = new Date().getTime();
					this.upload_time = -1;
				} else if (time.startsWith("error")) {
					this.error = time;
					time = "error";
				} else {
					this.upload_time = new Date().getTime();
				}

				this.$emit("change_status", this.id, time);
			},
			getRules() {
				var result = "";
				try {
					var result = $("#builder-" + this.action_id).queryBuilder(
						"getSQL",
						false
					).sql;
					// console.log(result)
					result = result.replace(
						/`([^`]*)` = ''/gi,
						"(`$1` = '' or `$1` is NULL)"
					);
					result = result.replace(
						/`([^`]*)` != ''/gi,
						"(`$1` != '' and `$1` is not NULL)"
					);
					result = result.replace(/\\"/gi, '"');
					// result = result.replace(/`/g, "'")
					// console.log(result)
				} catch (err) {
					result = "";
				}

				result = result.replace(
					/([^ ]*) = (letters)\((.*?)\)( |$)/g,
					"$2($1,$3)"
				);

				return result;

				alasql.fn.letters = function (str, search) {
					for (var i = 0; i < search.length; i++) {
						if (str.includes(search[i])) return true;
					}
					return false;
				};

				var res = alasql("SELECT * FROM ? WHERE " + result.sql, [
					this.tabulator_data,
				]);

				var id_list = [];
				for (var i = 0; i < res.length; i++) {
					id_list.push(res[i].id);
				}

				var table = this.$refs.tabulator.getInstance();

				var rows = table.getRows();
				for (var i = 0; i < rows.length; i++) {
					if (id_list.includes(rows[i].getData().id))
						rows[i].getElement().style.backgroundColor = "blue";
					else rows[i].getElement().style.backgroundColor = "white";
				}
			},
			event_data: function (data) {
				this.tabulator_data = data;
			},
			get_data: function () {
				return this.tabulator_data;
			},
			get_data_blob: async function () {
				var str_csv = json2csv.parse(this.tabulator_data, {
					fields: Object.keys(this.tabulator_data[0]),
					fieldNames: Object.keys(this.tabulator_data[0]),
				});
				return new Blob([str_csv], {
					type: "text/plain",
				});
			},
			get_data_files: async function (all_files = true) {
				if (!all_files) 
					return this.results_files;

				console.log(this.tabulator_data)

				if (!this.tabulator_data || this.tabulator_data.length == 0)
					return [];

				var str_csv = json2csv.parse(this.tabulator_data, {
					fields: Object.keys(this.tabulator_data.length > 0 ? this.tabulator_data[0] : []),
					fieldNames: Object.keys(this.tabulator_data.length > 0 ? this.tabulator_data[0] : []),
				});

				return this.results_files.concat([
					new File([str_csv], this.name_file || "data.csv", {
						type: "text/csv",
					}),
				]);
			},
			get_name_file()
			{
				return this.name_file || "data.csv";
			},
			get_params_data() {
				// Synchroniser les paramètres depuis les composants avant de retourner les données
				this.data.sql_rules = this.getRules();

  				// Fonctions excel
				if (this.action.toLowerCase() === "fonctions excel") {
					if (this.$refs.fonctionsExcelComponent) {
						let result = this.$refs.fonctionsExcelComponent.validateFunctionsForStep();
						var functions = this.$refs.fonctionsExcelComponent.getFunctions();
						this.data.parameters.fonctions = functions;
					}
				}

				// Composants avec méthode save()
				if (this.action_components.includes(this.action))
				{
					if (this.$refs.editor && this.$refs.editor.save) {
						this.data.parameters = this.component_save();
					}
				}
				// Autres actions avec éditeur JSONEditor
				else if (this.editor && this.action.toLowerCase() !== "zone_extract")
				{
					try {
						this.data.parameters = this.editor.getValue();
					} catch(e) {
						// editor not ready (e.g. called on a non-active step) — keep existing data.parameters
					}
				}
				// Zone extract cas spécial
				else if (this.editor && this.action.toLowerCase() === "zone_extract")
				{
					try {
						if (this.editor.getValue().params)
							this.data.parameters = JSON.parse(this.editor.getValue().params);
						else
							this.data.parameters = {};
					} catch(e) {
						// editor not ready — keep existing data.parameters
					}
				}

				// Treatment params
				if (this.$refs.treatment_params)
					this.data.parameters.params = this.$refs.treatment_params.get_obj();

				return this.data;
			},
			get_id() {
				return this.id;
			},
			get_keep_start_data() {
				return this.keep_start_data;
			},
			get_treatment() {
				return this.treatment;
			},
			async update_project() {
				var self = this;
				// console.log(this.project_id)
				this.project_is_archived = false;
				for (var i = 0; i < this.projects.length; i++) {
					if (this.projects[i].uid == this.project_id) {
						this.project = this.projects[i];
						console.log(this.project)
						this.treatment_params = this.project.details.treatment_params || [];
						this.user_params_save_default = this.project.details.details.details ? (this.project.details.details.details.user_params_save_default || "") : "";
						this.user_params_save = this.project.details.details ? (this.project.details.details.user_params_save || "") : "";
						this.$nextTick(async function () {
							if (self.treatment_params && self.treatment_params.length > 0)
								self.$refs.treatment_params.set(self.treatment_params)
						});
						await this.setParameters();
						return;
					}
				}
				// Chercher dans les projets archivés
				for (var i = 0; i < this.projects_archive.length; i++) {
					if (this.projects_archive[i].uid == this.project_id) {
						this.project = this.projects_archive[i];
						this.project_is_archived = true;
						this.treatment_params = this.project.details.treatment_params || [];
						this.user_params_save_default = this.project.details.details.details ? (this.project.details.details.details.user_params_save_default || "") : "";
						this.user_params_save = this.project.details.details ? (this.project.details.details.user_params_save || "") : "";
						this.$nextTick(async function () {
							if (self.treatment_params && self.treatment_params.length > 0)
								self.$refs.treatment_params.set(self.treatment_params)
						});
						await this.setParameters();
						return;
					}
				}
			},
			setResults(
				results,
				prev_data,
				errors = [],
				results_files,
				name_file,
				type_result,
				results_file,
				urls,
				script_logs = [],
				script_logs_total = 0,
				prev_name_file = ''
			) {
				this.statut = "";
				this.view_file = false;
				this.view_file_prev = false;

				this.urls = urls || [];
				this.name_file = name_file || "";
				this.prev_name_file = prev_name_file || "";

				if (results && results.length > 0)
				{
					let newColumns = Object.keys(results[0]);

					// if fonctionsExcelComponent ref exists
					if (this.$refs.fonctionsExcelComponent) {
						this.$refs.fonctionsExcelComponent.setNewColumns(newColumns);

						this.$refs.fonctionsExcelComponent.setPlayTestResult(results);
					}
				}

				try {
					if (this.keep_start_data == false)
						this.tabulator_data = results || [];
					else 
						this.tabulator_data = prev_data || [];
					this.$refs.result_test.set_option_delete(
						this.option_delete
					);
					this.$refs.result_test.set_data(results || []);
				} catch (err) {}

				if (typeof errors == "string")
				{
					if (errors == "")
						errors = [];
					else
						errors = errors.split('\n').map(l => l.trim()).filter(l => l);
				}
				this.errors = errors || [];
				this.results_files = results_files || [];
				this.script_logs = Array.isArray(script_logs) ? script_logs : [];
				this.script_logs_total = script_logs_total || this.script_logs.length;

				if (this.action.toLowerCase() === 'chatgpt_v2' || this.action.toLowerCase() === 'perplexity')
				{
					this.$refs.editor.get_cost();
				}
			},
			getUrls() {
				return this.urls;
			},
			setUrls(urls) {
				this.urls = urls;
			},
			download_url_direct(url) {
				treatments.getFileAlyx(url.url, true, "arraybuffer", url.name);
			},
			dowload_file(file) {
				const url = window.URL.createObjectURL(file);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", file.name);
				document.body.appendChild(link);
				link.click();
			},
			dowload_url(url, actual) {
				var self = this;
				if (url.name/*.endsWith(".csv") || url.name.endsWith(".pdf")*/) 
				{
					if (actual) 
					{
						this.view_file = true;
						this.$nextTick(async function () {
							self.$refs.view_file.viewFile(url.url, url.name);
						});
					} 
					else
					{
						this.view_file_prev = true;
						this.$nextTick(async function () {
							self.$refs.view_file_prev.viewFile(
								url.url,
								url.name
							);
						});
					}
				} 
				else 
				{
					treatments.getFileAlyx(
						url.url,
						true,
						"arraybuffer",
						url.name
					);
				}
			},
			makeList() {
				var data = this.$refs.result_test.get_data();
				this.$emit("make_list", data, "word");
			},
			testByLine(lots = false)
			{					
				console.log("test_by_line")

				this.redrawEditTabulator();

				this.test_line_nb = 0;
				this.stop_test = false;

				this.data.sql_rules = this.getRules();

				// if step === "fonctions excel"
				if (this.action.toLowerCase() === "fonctions excel") {
					// check if the component has js errors
					let result = this.$refs.fonctionsExcelComponent.validateFunctionsForStep();
					var functions = this.$refs.fonctionsExcelComponent.getFunctions();
					this.data.parameters.fonctions = functions;

					// if yes, return
					if (result === false) {
						console.log("Errors detected in fonctions excel component");
						return;
					}
				}

				if (this.action_components.includes(this.action))
				{
					this.data.parameters = this.component_save();
				}
				if (!this.data.parameters || typeof this.data.parameters !== "object")
					this.data.parameters = {};
				else if (Array.isArray(this.data.parameters) && this.action.toLowerCase() !== "api")
					this.data.parameters = {};

				if (this.$refs.treatment_params)
					this.data.parameters.params = this.$refs.treatment_params.get_obj();

				this.$nextTick(function () {
					if (this.data.hasOwnProperty("element"))
					{						
						if (!this.data.parameters || typeof this.data.parameters !== "object")
							this.data.parameters = {};
						else if (Array.isArray(this.data.parameters) && this.action.toLowerCase() !== "api")
							this.data.parameters = {};
						this.data.parameters.element = this.data.element;
					}
					this.error = false;
					this.start_time = -2;
					this.dowload_time = -2;
					this.treatment_time = -2;
					this.upload_time = -2;
					this.statut = "en cours";
					if (this.c_tabulator)
						this.data.tabulator2 =
							this.$refs.edit_tabulator.get_data();
					this.$emit(
						"test_by_line",
						this,
						this.id,
						this.data,
						lots
					);
				});
			},
			test(before) {
				this.redrawEditTabulator();

				this.data.sql_rules = this.getRules();

				// if step === "fonctions excel"
				if (this.action.toLowerCase() === "fonctions excel") {
					// check if the component has js errors
					let result = this.$refs.fonctionsExcelComponent.validateFunctionsForStep();
					var functions = this.$refs.fonctionsExcelComponent.getFunctions();
					this.data.parameters.fonctions = functions;

					// if yes, return
					if (result === false) {
						console.log("Errors detected in fonctions excel component");
						return;
					}
				}

				if (this.action_components.includes(this.action))
				{
					this.data.parameters = this.component_save();
				}
				if (!this.data.parameters || typeof this.data.parameters !== "object")
					this.data.parameters = {};
				else if (Array.isArray(this.data.parameters) && this.action.toLowerCase() !== "api")
					this.data.parameters = {};

				if (this.$refs.treatment_params)
					this.data.parameters.params = this.$refs.treatment_params.get_obj();

				this.$nextTick(function () {
					if (this.data.hasOwnProperty("element"))
					{						
						if (!this.data.parameters || typeof this.data.parameters !== "object")
							this.data.parameters = {};
						else if (Array.isArray(this.data.parameters) && this.action.toLowerCase() !== "api")
							this.data.parameters = {};
						this.data.parameters.element = this.data.element;
					}
					this.error = false;
					this.start_time = -2;
					this.dowload_time = -2;
					this.treatment_time = -2;
					this.upload_time = -2;
					this.statut = "en cours";
					if (this.c_tabulator)
						this.data.tabulator2 =
							this.$refs.edit_tabulator.get_data();
					this.$emit(
						"test",
						this,
						this.id,
						this.data,
						before,
						this.keep_start_data,
						this.treatment,
						0
					);
				});
			},
			setConditions() {
				var self = this;

				try {
					//console.log("Action id: ", this.action_id);
					$("#builder-" + this.action_id).queryBuilder(this.config);

					$("#builder-" + this.action_id).on(
						"afterDeleteGroup.queryBuilder afterAddRule.queryBuilder afterDeleteRule.queryBuilder afterUpdateRuleValue.queryBuilder afterUpdateRuleOperator.queryBuilder afterUpdateGroupCondition.queryBuilder afterUpdateRuleFilter.queryBuilder",
						function (e, rule, error, value) {
							if (self._loading) return;
							self.data.rules = $(
								"#builder-" + self.action_id
							).queryBuilder("getRules");
							self.$emit(
								"change",
								self.id,
								self.data,
								self.steps,
								self.description,
								self.source_data,
								self.file_result,
								self.source_data_ids
							);
						}
					);
				} catch (err) {
					console.warn("Error in setconditions: ", err);
				}
			},
			update_tree(data) {
				if (!this.data) this.data = {};

				this.data.tree = data;
			},
			// * setParameters() détruit puis recrée this.editor ; si deux appels se chevauchent
			// * (ex: prev_data modifié deux fois de suite très rapidement), le second appel peut
			// * écraser this.editor pendant que le premier est encore en train de le restaurer,
			// * ce qui corrompt/réinitialise data.parameters. On sérialise donc les appels ici.
			async setParameters() {
				if (this._setParametersRunning) {
					this._setParametersPending = true;
					return;
				}
				this._setParametersRunning = true;
				try {
					await this._setParametersImpl();
				} finally {
					this._setParametersRunning = false;
					if (this._setParametersPending) {
						this._setParametersPending = false;
						this.setParameters();
					}
				}
			},
			async _setParametersImpl() {
				//console.log("setParameters")
				var self = this;

				if (!this.data) this.data = {};

				if (this.$refs.treatment_params && this.data.parameters && this.data.parameters.params)
					this.$refs.treatment_params.set_obj(this.data.parameters.params);

				var json = null;
				if (this.editor) {
					while (!this.ready) {
						await new Promise((resolve) =>
							setTimeout(resolve, 100)
						);
					}
					json = this.editor.getValue();
				}

				if (this.editor) {
					this.editor.destroy();
					this.editor = null;
				}

				this.keep_start_data = false;
				this.option_delete = false;
				this.option_make_list = false;
				this.treatment = false;

				var schema = {};
				var display_required_only = false;

				let prevColumnNames = [];
				if (this.prev_data.length > 0)
					prevColumnNames = Object.keys(this.prev_data[0]);
				else {
					// * au cas où on n'a pas de données precedentes
					for (let i = 0; i < this.columns.length; i++) {
						if (this.columns[i].colonne.length === 0) continue;
						if (
							prevColumnNames.indexOf(this.columns[i].colonne) ===
							-1
						)
							prevColumnNames.push(this.columns[i].colonne);
					}
				}

				this.availableColumns = prevColumnNames;

				if (this.columnDropdownOrderPref === "alphabetical") {
					// ! attention intégration avec composant mapping qui a besoin de trier la liste d'origine potentiellement
					// * order prevColumnNames by alphabetical order
					prevColumnNames.sort((a, b) => {
						let lowerCaseA = a.toLowerCase(),
							lowerCaseB = b.toLowerCase();
						if (lowerCaseA < lowerCaseB) return -1;
						if (lowerCaseA > lowerCaseB) return 1;
						return 0;
					});
				}

				this.usesPrevColumnNames = false;
				
                this.toggleShowJSONEditor(true);
				this.elements = [];
				this.elements_type = "";
				this.test_line = false;

				this.treatment_params_elements = [];

				//console.log(this.action)
				switch (this.action) {
					case "fonctions excel":
						this.toggleShowJSONEditor(false);
						schema = schema_fonctions_excel();
						this.test_line = true;
						break;
					case "scraping":
						//display_required_only = true;
						//schema = scrapingSchema;
						this.test_line = true;
						break;
					case "api":
						// handled by api_step component
						this.test_line = true;
						break;
					case "siren":
						this.test_line = true;
						break;
					case "xlsx":
						schema = schema_xlsx();
						break;
					case "rules":
						this.toggleShowJSONEditor(false);
						this.test_line = true;
						
						var elements = await library.getby_production('rules')						
						elements = elements.element;
						
						//console.log(elements)
0
						for (var i = 0; i < elements.length; i++)
						{
							this.elements.push({
								text: elements[i].name,
								value: elements[i].name
							})							
						}
						break;
					case "chatgpt":
						this.test_line = true;
						schema = schema_chatgpt();
						display_required_only = true;
						break;
					case "chatgpt_train":
						schema = schema_chatgpt_train();
						break;
					case "pdf_extract":
						schema = schema_pdf_extract();
						break;
					case "zone_extract":
						schema = schema_zone_extract();
						break;
					case "ocr":
						schema = schema_ocr();
						break;
					case "abbyy":
						schema = schema_abby();
						break;
					case "agenda":
						// handled by agenda_step component
						this.test_line = true;
						break;
					case "magick_convert":
						schema = schema_magick_convert();
						break;
					case "prediction":
						schema = schema_prediction();
						break;
					case "group":
						schema = schema_group();
						break;
					case "docx":
						schema = schema_docx();
						break;
					case "vision":
						schema = schema_vision();
						break;
					case "zone_final_extract":
						schema = schema_zone_final_extract();
						break;
					case "split_zone":
						schema = schema_split_zone();
						this.test_line = true;
						break;
					case "sequence":
						schema = schema_sequence();
						this.test_line = true;
						break;
					case "zip":
						schema = schema_zip();
						break;
					case "share_document":
						schema = schema_share_document();
						break;
					case "fonction":
						display_required_only = true;
						this.test_line = true;

						schema = schema_fonction();
						break;
					case "blacklist_whitelist":
						this.test_line = true;
						var elements = await library.getby_production('rules')						
						elements = elements.element;
						
						//console.log(elements)
0
						for (var i = 0; i < elements.length; i++)
						{
							if (elements[i].data.indexOf('{"image":true') == 0)
							{
								console.log(elements[i].data)
								console.log(elements[i].data.indexOf('{"image":true'))
								elements[i] = elements[i].name;
							}
							else
							{
								elements.splice(i, 1);				
								i--;
							}
						}

						elements.unshift("")

						schema = schema_blacklist_whitelist(elements);
						break;
					case "fusionner lignes":
						// handled by fusionner_lignes component
						break;
					case "ftp":
						schema = schema_ftp();
						break;
					case "supprimer lignes":
						// handled by supprimer_lignes_step component
						this.test_line = true;
						break;
					case "send_notifications":
						// handled by send_notifications_step component
						this.test_line = true;
						break;
					case "sort":
						// handled by sort_step component
						break;
					case "projet":
						this.treatment = true;
						break;
					case "hit parade":
						schema = schema_hit_parade(prevColumnNames);
						this.usesPrevColumnNames = true;
						this.keep_start_data = true;
						this.option_delete = true;
						this.option_make_list = true;
                        display_required_only = true;
						break;
					case "conversion":
						schema = schema_conversion(prevColumnNames);
						this.usesPrevColumnNames = true;
						this.test_line = true;
						break;
					case "nettoyage":
						schema = schema_nettoyage(prevColumnNames);
						this.usesPrevColumnNames = true;
						this.test_line = true;
						break;
					case "textrazor":
						schema = schema_textrazor(prevColumnNames);
						this.usesPrevColumnNames = true;
						break;
					case "firecrawl":
						this.test_line = true;
						break;
					case "linkedin":
						this.test_line = true;
						break;
					case "splashsync":
						this.test_line = true;
						break;
					case "prestashop":
						this.test_line = true;
						break;
					case "translate":
						// handled by translate_step component
						this.test_line = true;
						break;
					case "split":
						// handled by split_step component
						this.test_line = true;
						break;
					case "split_json":
						this.test_line = true;
						break;
					case "deux points":
						schema = schema_deux_points(prevColumnNames);
						this.usesPrevColumnNames = true;
						this.test_line = true;
						break;
					case "library":
						schema = schema_library(prevColumnNames);
						this.usesPrevColumnNames = true;
						break;
					case "user_details":
						schema = schema_user_details(prevColumnNames);
						this.usesPrevColumnNames = true;
						break;
					case "chercher et classer":
						// handled by chercher_et_classer component
						this.test_line = true;
						break;
					case "chercher et remplacer":
						schema = schema_chercher_et_remplacer(prevColumnNames);
						this.usesPrevColumnNames = true;
						this.test_line = true;
						break;
					case "mapping colonnes":
						// handled by mapping_colonnes_step component
						this.test_line = true;
						break;
					case "mapping colonnes - fichier cible":
						var columns = [];
						if (this.cible_data.length > 0)
							columns = Object.keys(this.cible_data[0]);
						for (var i = 0; i < columns.length; i++) {
							columns[i] = {
								colonne: columns[i],
								mapping: columns[i],
							};
						}
						schema = schema_mapping_colonnes_fichier_cible(
							prevColumnNames,
							columns
						);
						this.usesPrevColumnNames = true;
						break;
					case "correspondance":
						this.test_line = true;
						var columns = [];
						var columns_obj = [];
						var data = this.$refs.edit_tabulator.get_data();
						if (data.length > 0) {
							columns = Object.keys(data[0]);
						}
						if (
							columns.length == 0 &&
							this.data &&
							this.data.parameters
						) {
							if (this.data.parameters.colonnes) {
								columns = columns.concat(
									this.data.parameters.colonnes
								);
							}
							if (this.data.parameters.colonnes_id) {
								columns = columns.concat(
									this.data.parameters.colonnes_id
								);
							}
						}
						for (var i = 0; i < columns.length; i++) {
							columns_obj.push({
								actif: false,
								colonne: columns[i],
								poids: 1,
							});
						}
						if (json && json.colonnes_opt.length == 0)
							json.colonnes_opt = columns_obj;
						schema = schema_correspondance(columns);
						this.usesPrevColumnNames = true;
						break;
					case "opérations sur colonnes":
						schema =
							schema_operations_sur_colonnes(prevColumnNames);
						this.usesPrevColumnNames = true;
						this.test_line = true;
						break;
					case "referentiel":
						schema = schema_referentiel();
						this.test_line = true;
						break;
					case "mail":
						this.test_line = true;
						break;
					case "file":
						// handled by file_step component
						break;
					case "pdf":
						schema = schema_pdf();
						break;
					case "html":
						// handled by html_step component
						break;
					case "insee":
						schema = schema_insee(prevColumnNames);
						this.usesPrevColumnNames = true;
						this.test_line = true;
						break;
					case "google_sheets":
						schema = schema_api();
						this.toggleShowJSONEditor(false);
						this.test_line = true;
						break;
                    case "airtable":
						this.test_line = true;
                        break;
                    case "n8n":
                        schema = schema_api();
                        this.toggleShowJSONEditor(false);
						this.test_line = true;
                        break;
					case "chatgpt_v2":
						this.treatment_params_elements = [{
							"value": "",
							"step_uid": this.id,
							"name": "content",
							"libelle": "Requête",
							"description": "Requête",
							"jsonpath": "content",
							"required": true,
							"default": "",
							"type": {
								"type": "textarea_plus"
							}
						}]
						this.test_line = true;
						break;
					case "perplexity":
						this.treatment_params_elements = [{
							"value": "",
							"step_uid": this.id,
							"name": "content",
							"libelle": "Requête",
							"description": "Requête",
							"jsonpath": "content",
							"required": true,
							"default": "",
							"type": {
								"type": "textarea_plus"
							}
						}]
						this.test_line = true;
						break;
					default:
						schema = {
							title: "Paramètres",
							type: "object",
						};
				}

				if (this.action_components.includes(this.action))
				{
					schema = schema_free();
                    this.toggleShowJSONEditor(false);
					if (this.action === "base de données")
						this.test_line = true;
				}

				//console.log("end switch")

				if (this.currentRequest != null) {
					// * schema = api schema
					display_required_only = true;
					schema = requestSchema;
				}

				if (schema.properties) {
					schema.properties.strict = {
						type: "boolean",
						options: { hidden: true },
					};
					schema.properties.cut_start = {
						type: "boolean",
						options: { hidden: true },
					};
					schema.properties.cut_end = {
						type: "boolean",
						options: { hidden: true },
					};
				}

				const element = document.getElementById(
					"jsoneditor-" + this.action_id
				);

				var self = this;

				// * pour les actions migrées vers un composant Vue dédié (action_components),
				// * la sauvegarde/chargement passe entièrement par this.$refs.editor.save()/load()
				// * (cf get_params_data(), save(), component_load()) : ce JSONEditor caché n'est
				// * jamais lu ni écrit pour ces actions. On évite donc sa création (gain de temps,
				// * et suppression d'un handler "change" mort qui pouvait interférer avec
				// * data.parameters lors des reconstructions de setParameters()).
				if (element && !this.action_components.includes(this.action))
				{
					console.log("create " + this.action_id)
					
					// * la création du json editor peut durer 1 seconde * le nombre d'étapes...
					this.editor = new JSONEditor(element, {
						schema: schema,
						keep_oneof_values: false,
						theme: "bootstrap4",
						iconlib: "fontawesome5",
						prompt_before_delete: false,
						object_background: "",
						display_required_only: display_required_only,
						disable_edit_json: true,
						disable_properties: true,
						template: "handlebars",
					});

					var editorRef = this.editor;

					this.ready = false;
					await new Promise((resolve, reject) => {
						self.editor.on("ready", function () {
							
							console.log("editor ready")

							if (editorRef)
							{
								self.addColAutocompleteToJSON(
									editorRef,
									prevColumnNames,
									"dropdown-colonne"
								);
								self.addColAutocompleteToJSON(
									editorRef,
									self.tables,
									"dropdown-table"
								);
							}
							self.ready = true;

							if (resolve) resolve();
						});
					});

					this.editor.on("change", function () {
						if (editorRef)
						{
							self.addColAutocompleteToJSON(
								editorRef,
								prevColumnNames,
								"dropdown-colonne"
							);
							self.addColAutocompleteToJSON(
								editorRef,
								self.tables,
								"dropdown-table"
							);
						}

						//console.log("Updated json editor");

						if (self.action == "zone_extract") 
						{
							if (self.editor.getValue().params)
								self.data.parameters = JSON.parse(self.editor.getValue().params);
							else 
								self.data.parameters = {};
						}
						else if (self.action_components.includes(self.action))
						{
							self.data.parameters = self.component_save();
						}
						else 
							self.data.parameters = self.editor.getValue();

						if (self.$refs.treatment_params)
							self.data.parameters.params = self.$refs.treatment_params.get_obj();
							
						//if (self.action == "base de données" || self.action == "chercher et classer")
						//    self.data.parameters.token = self.client.details.database_token;
						self.$emit(
							"change",
							self.id,
							self.data,
							self.steps,
							self.description,
							self.source_data,
							self.file_result,
							self.source_data_ids
						);
					});
				}

				if (this.action == "chatgpt")
				{
					this.elements = [];
					this.elements_type = "chatgpt";
					var elements = await library.getby_production('chatgpt')						

					elements = elements.element;
					
					this.elements.push({ value: null, text: '' })

					for (var i = 0; i < elements.length; i++)
					{
						this.elements.push({
							text: elements[i].name,
							value: elements[i].name
						})							
					}
				}

				if (this.action_components.includes(this.action))
				{
					// * pas de JSONEditor pour ces actions (cf plus haut) : json est toujours null ici,
					// * on charge donc systématiquement le composant dédié depuis data.parameters.
					this.component_load(this.data.parameters);
				}
				else if (json) {
					if (this.action == "zone_extract") 
					{
						if (json.params) 
							this.editor.setValue(json);
						else
							this.editor.setValue({params: JSON.stringify(json, null, " ")});
					} 
					else if (this.editor) 
						this.editor.setValue(json);
				} else if (!self.data.parameters) {
					if (self.action == "zone_extract") 
					{
						if (self.editor.getValue().params)
							self.data.parameters = JSON.parse(self.editor.getValue().params);
						else 
							self.data.parameters = {};
					} 
					else 
						self.data.parameters = self.editor.getValue();
				}

				if (self.$refs.fonctionsExcelComponent)
				{
					console.log("editor ready - step")
					self.$refs.fonctionsExcelComponent.editor_ready();
				}

				// * debug
				// setTimeout(() => {
				//     console.log("Toggling advanced JSON options to false after 10 seconds");
				//     this.toggleAdvancedJSONOptions(false);
				// }, 10000);
			},
			add_treatment_params_element(idx)
			{
				var element = this.treatment_params_elements[idx];

				var treatment_params = this.editor_user_params.getValue();
				for (var i = 0; i < treatment_params.length; i++)
				{
					if (treatment_params[i].jsonpath == element.jsonpath)
						return;
				}
				treatment_params.push(element);
				this.editor_user_params.setValue(treatment_params);
			},
			toggleAdvancedJSONOptions() {
				let toggle = this.showJSONParams;

				let newOptions = clone(this.editor.options);

				// * peut-être une variable pour garder le state
				newOptions.disable_edit_json = !toggle;
				newOptions.disable_properties = !toggle;

				this.changeJSONOptions(newOptions);
			},
			async changeJSONOptions(options) {
				var self = this;

				if (!this.editor) {
					return;
				}

				const element = document.getElementById(
					"jsoneditor-" + this.action_id
				);

				// * get value from current editor
				var json = this.editor.getValue();
				options.startval = json;

				// * le schema actuel est contenu dans les options donc on fait confiance

				self.ready = false;
				this.editor.destroy();
				this.editor = new JSONEditor(element, options);

				/*await new Promise((resolve, reject) => {
					self.editor.on("ready", function () {
						if (resolve) resolve();
					});
				});*/

				var editorRef = this.editor;

				// * en espérant que availableColumns se fait pas mutiler entre temps
				var prevColumnNames = this.availableColumns;

				await new Promise((resolve, reject) => {
					self.editor.on("ready", function () {
						self.addColAutocompleteToJSON(
							editorRef,
							prevColumnNames,
							"dropdown-colonne"
						);
						self.addColAutocompleteToJSON(
							editorRef,
							self.tables,
							"dropdown-table"
						);

						self.ready = true;
						if (resolve) resolve();
					});
				});

				this.editor.on("change", function () {
					self.addColAutocompleteToJSON(
						editorRef,
						prevColumnNames,
						"dropdown-colonne"
					);
					self.addColAutocompleteToJSON(
						editorRef,
						self.tables,
						"dropdown-table"
					);

					if (self.action == "zone_extract") 
					{
						if (self.editor.getValue().params)
							self.data.parameters = JSON.parse(self.editor.getValue().params);
						else 
							self.data.parameters = {};
					} 
					else if (self.action_components.includes(self.action))
						self.data.parameters = self.component_save();
					else 
						self.data.parameters = self.editor.getValue();

					
					if (self.$refs.treatment_params)
						self.data.parameters.params = self.$refs.treatment_params.get_obj();
						
					//if (self.action == "base de données" || self.action == "chercher et classer")
					//    self.data.parameters.token = self.client.details.database_token;
					self.$emit(
						"change",
						self.id,
						self.data,
						self.steps,
						self.description,
						self.source_data,
						self.file_result,
						self.source_data_ids
					);
				});
			},
			// * autocomplete sur les colonnes
			addColAutocompleteToJSON(editorRef, prevColumnNames, fieldClass) {
				var ed = editorRef.getEditor("root");

				if (prevColumnNames.length === 0) {
					return;
				}
				// remove undefined items
				prevColumnNames = prevColumnNames.filter(function (item) {
					return item !== undefined;
				});

				var elements =
					ed.jsoneditor.element.querySelectorAll(".form-group");
				// var elements = document.querySelectorAll('.form-group');
				// console.log("Found form group elements: ", elements);

				// * you need to add a child to each formgroup:
				elements.forEach((elem) => {
					let input = elem.querySelector("input");

					// console.log("Searching for fieldClass:", fieldClass);
					if (
						input === null ||
						!$(input).hasClass(fieldClass) ||
						$(input).hasClass("my-autocomplete")
					) {
						return;
					}

					// * checke s'ils ont déjà un autocomplete dessus ?

					// * cette classe c'est pour profiter de leur CSS, mais il clashe avec bootstrap
					// $(input).addClass("autocomplete-input");
					$(input).addClass("my-autocomplete");

					// * en revanche il faut ce <ul> et je suis preneur du CSS
					let ulElem = elem.appendChild(document.createElement("ul"));
					$(ulElem).addClass("autocomplete-result-list");
				});

				const search = (input) => {
					let colonnes = prevColumnNames;

					if (input.length < 1) {
						return [];
					}

					return colonnes.filter((colonne) => {
						return colonne.includes(input);
					});
				};

				// Attach autocomplete to each element
				elements.forEach((el) => {
					let input = el.querySelector("input");
					if (input === null || !$(input).hasClass(fieldClass)) {
						return;
					}

					// console.log("Attaching autocomplete to parent element ", el);

					try {
						new Autocomplete(el, { search, autoSelect: true });
						// console.log("Successfully attatched autocomplete");
					} catch (error) {
						console.log(
							"Failed to attach autocomplete to input ",
							error
						);
					}
				});
			},
			getAction() {
				return this.action;
			},
			async setAction(action, label = "") {
				if (action) this.action = action;
				if (label && label.length > 0) {
					this.actionLabel = label;

					// * si notre label correspond à une de nos requetes perso, assigner la variable
					// * load la request
					if (
						this.requestsPersoLabels.find(
							(requestLabel) => requestLabel === label
						)
					) {
						this.action = "api";
						await this.getSelectedRequest(label);
					} else this.currentRequest = null;
				}

				var self = this;

				if (this.editor) {
					this.editor.destroy();
					this.editor = null;
				}

				this.c_tabulator = false;
				this.c_conditions = true;
				this.c_parameters = true;
				this.c_tree = false;
				this.c_project = false;
				switch (this.action) {
					case "fusionner lignes":
						this.c_conditions = false;
						break;
					case "projet":
						this.c_project = true;
						break;
					case "rules":
						this.c_conditions = true;
						break;
					case "conversion":
						this.c_conditions = false;
						break;
					case "chercher et classer":
						this.c_conditions = false;
						break;
					case "sort":
						this.c_conditions = false;
						break;
					case "hit parade":
						this.c_conditions = false;
						break;
					case "textrazor":
						this.c_conditions = false;
						break;
					case "html":
						this.c_conditions = false;
						break;
					case "pdf_extract":
						this.c_conditions = false;
						break;
					case "zone_extract":
						this.c_conditions = false;
						break;
					case "zone_final_extract":
						this.c_conditions = false;
						break;
					case "insee":
						this.c_conditions = false;
						break;
					case "ocr":
						this.c_conditions = false;
						break;
					case "abbyy":
						this.c_conditions = false;
						break;
					case "docx":
						this.c_conditions = false;
						break;
					case "vision":
						this.c_conditions = false;
						break;
					case "xlsx":
						this.c_conditions = false;
						break;
					case "scraping":
						this.c_conditions = false;
						break;
					case "mapping":
						break;
					case "mail":
						this.c_conditions = false;
						break;
					case "referentiel":
						this.c_conditions = false;
						this.c_tree = true;
						break;
					case "correspondance":
						this.c_tabulator = true;
						this.c_conditions = false;
						break;
					case "correspondance_v2":
						this.c_conditions = false;
						break;
					case "file":
						this.c_conditions = false;
						break;
					case "pdf":
						this.c_conditions = false;
						break;
				}

				if (this.currentRequest) {
					this.c_conditions = true;
					this.c_parameters = true;
				}

				if (this.c_conditions) this.setConditions();
				if (this.c_parameters) {
					try {
						await this.setParameters();
					} catch (err) {
						// * ne jamais laisser une erreur ici empêcher c_test de passer à true
						// * (sinon plus de bouton test, plus d'options ⚙ pour l'étape)
						console.log("Error in setParameters: ", err);
					}
				}
				this.c_test = true;
				this.data.action = this.action;
				this.data.label = this.actionLabel;
				this._loading = false;
				this.$emit(
					"change",
					this.id,
					this.data,
					this.steps,
					this.description,
                    this.source_data,
				this.file_result,
				this.source_data_ids
				);
			},
			// ── Helpers pour composants Vue (save/load + options communes) ──

			component_save() {
				if (!this.$refs.editor || !this.$refs.editor.save)
					return (this.data && this.data.parameters) || {};
				const p = this.$refs.editor.save();
				// Les flags strict/cut_start/cut_end sont injectés dans save() global
				return p;
			},
			_sync_source_data() {
				var self = this;
				var positions = (this.source_data_ids || []).map(function(uid) {
					if (uid === "import") return "import";
					var s = (self.steps_list || []).find(function(s) { return s.uid === uid; });
					return s ? String(s.position) : null;
				}).filter(Boolean);
				this.source_data = positions.join("|");
				return this.source_data;
			},
			apply_json_step() {
				var parsed;
				try { parsed = JSON.parse(this.json_step); } catch(e) { alert('JSON invalide'); return; }
				var uid = parsed.data && parsed.data.uid;
				this.$emit('check_uid', [uid, (isDuplicate) => {
					if (isDuplicate && parsed.data) {
						parsed.data.uid = this.$uuid.v4();
					}
					this.load(parsed);
				}]);
			},
			component_load(data) {
				if (!data) data = {};
				this.step_strict = !!data.strict;
				this.step_cut_start = !!data.cut_start;
				this.step_cut_end = !!data.cut_end;
				// * le composant enfant (v-if selon this.action) peut ne pas encore être monté
				// * (ex: juste après avoir changé this.action, avant le prochain tick de rendu Vue).
				// * On ne doit jamais laisser une exception ici remonter, sinon elle interrompt
				// * setAction() avant `this.c_test = true` (plus de bouton test, plus d'options ⚙).
				if (this.$refs.editor && this.$refs.editor.load)
					this.$refs.editor.load(data);
				else
					this.$nextTick(() => {
						if (this.$refs.editor && this.$refs.editor.load)
							this.$refs.editor.load(data);
					});
			},

			change_emit() {
				if (this._loading) return;
				// Synchroniser les paramètres
				if (this.action_components.includes(this.action) && this.$refs.editor && this.$refs.editor.save) {
					this.data.parameters = this.component_save();
				}
				// Injecter les options d'exécution pour toutes les étapes
				if (this.data.parameters && typeof this.data.parameters === 'object') {
					if (this.step_strict) this.data.parameters.strict = true; else delete this.data.parameters.strict;
					if (this.step_cut_start) this.data.parameters.cut_start = true; else delete this.data.parameters.cut_start;
					if (this.step_cut_end) this.data.parameters.cut_end = true; else delete this.data.parameters.cut_end;
				}
				this.$emit(
					"change",
					this.id,
					this.data,
					this.steps,
					this.description,
					this.source_data,
					this.file_result,
					this.source_data_ids
				);
			},
			change_user_params() {
				//console.log("change_user_params")
				//console.log(this.user_params)
				this.$emit(
					"change_user_params"
				);
			},
			get_users_params() {
				return this.user_params;
			},

			// ── Panneau params scénario (Phase 4) ───────────────────────────

			sp_open_form(mode) {
				this.sp_mode = mode;
				this.sp_link_name = null;
				this.sp_new_name = "";
				this.sp_new_libelle = "";
				this.sp_new_jsonpath = "";
				this.sp_new_jsonpath_custom = "";
				this.sp_new_param_name = "";
				this.sp_new_type = null;
				this.sp_type_user_set = false;
				this.sp_new_list_options = "";
				this.sp_error = "";
				this.sp_show_form = true;
			},
			sp_close_form() {
				this.sp_show_form = false;
				this.sp_error = "";
				this.sp_new_jsonpath = "";
				this.sp_new_jsonpath_custom = "";
				this.sp_new_param_name = "";
				this.sp_type_user_set = false;
				this.sp_new_list_options = "";
			},
			confirm_remove_step: async function () {
				var ok = await this.$bvModal.msgBoxConfirm(
					"Voulez-vous vraiment retirer cette étape ?",
					{ title: "Confirmer la suppression", okVariant: "danger", okTitle: "Retirer", cancelTitle: "Annuler" }
				);
				if (!ok) return;
				this.$emit("remove_step");
			},
			sp_build_type() {
				var k = this.sp_new_type || "texte";
				if (k === "date")     return { type: "texte",    html_type: "date" };
				if (k === "nombre")   return { type: "texte",    html_type: "number" };
				if (k === "textarea") return { type: "textarea" };
				if (k === "liste") {
					var options = (this.sp_new_list_options || "").split("\n")
						.map(l => l.trim()).filter(l => l)
						.map(l => { var s = l.indexOf(":"); return s > 0 ? { value: l.slice(0,s).trim(), text: l.slice(s+1).trim() } : { value: l, text: l }; });
					return { type: "list", options, multiple: false };
				}
				return { type: "texte", html_type: "text" };
			},
			sp_on_field_select(val) {
				if (val && val !== "__custom__") {
					this.sp_new_jsonpath_custom = "";
				}
			},
			sp_on_projet_param_select(val) {
				if (val && this.treatment_params) {
					var p = this.treatment_params.find(p => p.name === val);
					if (p && p.type && this.sp_new_type === null) {
						var t = p.type;
						if (t.type === "texte" && t.html_type === "number") this.sp_new_type = "nombre";
						else if (t.type === "texte" && t.html_type === "date") this.sp_new_type = "date";
						else if (t.type === "textarea") this.sp_new_type = "textarea";
						else if (t.type === "list") this.sp_new_type = "liste";
						else this.sp_new_type = "texte";
					}
					if (!this.sp_new_name) this.sp_new_name = p ? p.name : "";
					if (!this.sp_new_libelle) this.sp_new_libelle = p ? (p.libelle || "") : "";
				}
			},
			sp_submit() {
				var uid = this.data && this.data.uid;
				if (!uid) return;

				// Mode projet : target avec param_name
				if (this.c_project) {
					var param_name = (this.sp_new_param_name || "").trim();
					if (!param_name) { this.sp_error = "Le paramètre du projet fils est obligatoire."; return; }
					if (this.sp_mode === "link") {
						if (!this.sp_link_name) { this.sp_error = "Sélectionner un paramètre."; return; }
						this.$emit("add_param_target", {
							param_name: this.sp_link_name,
							target: { step_uid: uid, param_name }
						});
					} else {
						var name = this.sp_new_name.trim();
						if (!name) { this.sp_error = "Le nom est obligatoire."; return; }
						if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(name)) { this.sp_error = "Nom : doit commencer par une lettre ou _, puis lettres, chiffres et _."; return; }
						if (this.sp_existing_names.has(name)) { this.sp_error = "Ce nom est déjà utilisé."; return; }
						this.$emit("create_scenario_param", {
							name,
							libelle: this.sp_new_libelle.trim() || name,
							type: this.sp_build_type(),
							default_value: "",
							required: true,
							targets: [{ step_uid: uid, param_name }]
						});
					}
					this.sp_close_form();
					return;
				}

				// Mode script : créer un param sans target (accessible via treatment_params dans le script)
				if (this.sp_is_script) {
					var name = this.sp_new_name.trim();
					if (!name) { this.sp_error = "Le nom est obligatoire."; return; }
					if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(name)) { this.sp_error = "Nom : doit commencer par une lettre ou _, puis lettres, chiffres et _."; return; }
					if (this.sp_existing_names.has(name)) { this.sp_error = "Ce nom est déjà utilisé."; return; }
					this.$emit("create_scenario_param", {
						name,
						libelle: this.sp_new_libelle.trim() || name,
						type: this.sp_build_type(),
						default_value: "",
						required: true,
						targets: []
					});
					this.sp_close_form();
					return;
				}

				// Mode projet : target avec param_name
				if (this.c_project) {
					var param_name = this.sp_new_param_name.trim();
					if (!param_name) { this.sp_error = "Le paramètre du projet fils est obligatoire."; return; }
					if (this.sp_mode === "link") {
						if (!this.sp_link_name) { this.sp_error = "Sélectionner un paramètre."; return; }
						this.$emit("add_param_target", {
							param_name: this.sp_link_name,
							target: { step_uid: uid, param_name }
						});
					} else {
						var name = this.sp_new_name.trim();
						if (!name) { this.sp_error = "Le nom est obligatoire."; return; }
						if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(name)) { this.sp_error = "Nom : doit commencer par une lettre ou _, puis lettres, chiffres et _."; return; }
						if (this.sp_existing_names.has(name)) { this.sp_error = "Ce nom est déjà utilisé."; return; }
						this.$emit("create_scenario_param", {
							name,
							libelle: this.sp_new_libelle.trim() || name,
							type: this.sp_build_type(),
							default_value: "",
							required: true,
							targets: [{ step_uid: uid, param_name }]
						});
					}
					this.sp_close_form();
					return;
				}

				// Résoudre le jsonpath effectif
				var jsonpath = this.sp_new_jsonpath === "__custom__"
					? this.sp_new_jsonpath_custom.trim()
					: (this.sp_new_jsonpath || this.sp_new_jsonpath_custom || "").trim();

				if (this.sp_mode === "link") {
					if (!this.sp_link_name) {
						this.sp_error = "Sélectionner un paramètre.";
						return;
					}
					if (!jsonpath) {
						this.sp_error = "Le champ à remplacer est obligatoire.";
						return;
					}
					this.$emit("add_param_target", {
						param_name: this.sp_link_name,
						target: { step_uid: uid, jsonpath }
					});
				} else {
					var name = this.sp_new_name.trim();
					if (!name) {
						this.sp_error = "Le nom est obligatoire.";
						return;
					}
					if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(name)) {
						this.sp_error = "Nom : doit commencer par une lettre ou _, puis lettres, chiffres et _.";
						return;
					}
					if (this.sp_existing_names.has(name)) {
						this.sp_error = "Ce nom est déjà utilisé.";
						return;
					}
					if (!jsonpath) {
						this.sp_error = "Le champ à remplacer est obligatoire.";
						return;
					}
					this.$emit("create_scenario_param", {
						name,
						libelle: this.sp_new_libelle.trim() || name,
						type: this.sp_build_type(),
						default_value: "",
						required: true,
						targets: [{ step_uid: uid, jsonpath }]
					});
				}
				this.sp_close_form();
			},
			sp_remove_target(param_name) {
				var uid = this.data && this.data.uid;
				if (!uid) return;
				this.$emit("remove_param_target", { param_name, step_uid: uid });
			},
			change(id, data, steps) {
				for (var i = 0; i < this.steps.length; i++) {
					if ((this.steps[i].id = id)) {
						this.steps[i].steps = steps;
						this.steps[i].data = data;
						break;
					}
				}
				this.$emit(
					"change",
					this.id,
					this.data,
					this.steps,
					this.description,
					this.source_data,
					this.file_result,
					this.source_data_ids
				);
			},
			removeAt(idx) {
				this.steps.splice(idx, 1);
			},
			addStep: function () {
				this.steps.push({
					id:
						Date.now() +
						Math.floor(Math.random() * Math.floor(1000)),
				});
			},
			setColumns() {
				if (!this.columns) this.columns = [];

				var filters = [];
				for (var i = 0; i < this.columns.length; i++) {
					if (this.columns[i].colonne) {
						var type = "string";
						if (this.columns[i].type == "nombre") type = "double";
						filters.push({
							id:
								"`" +
								this.columns[i].colonne.replace(/'/gi, "\\'") +
								"`",
							label: this.columns[i].colonne,
							type: type,
							validation: {
								callback: function () {
									return true;
								},
							},
						});
					}
				}

				try {
					if (this.c_conditions && filters.length > 0) {
						// console.log("Filters: ", filters);
						$("#builder-" + this.action_id).queryBuilder(
							"setFilters",
							true,
							filters
						);
					}
				} catch (e) {
					console.warn(
						"Error while setting query filters on step ",
						this.actionLabel,
						this.description,
						e
					);
				}
			},
		},
		watch: {
			step_strict()  { this.change_emit(); },
			step_cut_start() { this.change_emit(); },
			step_cut_end() { this.change_emit(); },
			showJSONParams: {
				handler: function (newVal, oldVal) {
					this.toggleAdvancedJSONOptions();
				},
			},
			columnDropdownOrderPref: {
				handler: async function (newVal, oldVal) {
					// * je pourrais appeler sur le focus out mais je prefere ici c'est plus sûr
					this.setParameters();
				},
			},

			// * pas mis à jour si on change prev_data
			columns: {
				deep: true,
				handler: function (newVal, oldVal) {
					this.columns = newVal;

					this.setColumns();
					if (this.c_conditions) this.setConditions();
				},
			},
			prev_data: {
				deep: true,
				handler: async function () {
					this.$refs.prev_data_tabulator.set_data(this.prev_data);

					this.$refs.prev_data_tabulator.redraw(true);

					// * les actions migrées vers un composant Vue dédié (action_components) reçoivent
					// * déjà prev_data directement en prop réactive et gèrent elles-mêmes la mise à
					// * jour de leurs suggestions de colonnes (cf watch sur `data` dans ces composants).
					// * Appeler setParameters() ici détruirait/recréerait inutilement le JSONEditor
					// * (masqué pour ces actions) et rechargerait le composant enfant depuis
					// * data.parameters à chaque changement de prev_data, ce qui écrase les saisies
					// * en cours et provoque une réinitialisation de la configuration de l'étape.
					if (this.action_components.includes(this.action)) return;

					//console.log("Calling setparameters from watch prev_data");

					// * obligé de régén tout le JSON car le dropdown colonnes doit être mis à jour :')
					await this.setParameters();
				},
			},
			errors: {
				deep: true,
				handler: function () {
					this.$emit("change_errors", this.id, this.errors);
				},
			},
		source_data_ids: {
			handler: function () {
				this._sync_source_data();
				this.change_emit();
			},
			deep: true,
		},
		steps_list: {
			handler: function () {
				if (this.source_data_ids && this.source_data_ids.length > 0) {
					this._sync_source_data();
				}
			},
			deep: false,
		},
		file_result: {
			handler: function () {
				this.change_emit();
			},
		deep: true,
		},
	},
	async mounted() {
		var self = this;

		//new operator : https://github.com/mistic100/jQuery-QueryBuilder/issues/403
		this.menu = ActionList();

		this.config = {
				operators:
					$.fn.queryBuilder.constructor.DEFAULTS.operators.concat([
						{
							type: "letters",
							optgroup: "fonction",
							nb_inputs: 1,
							multiple: false,
							apply_to: ["string"],
						},
					]),

				lang: {
					operators: {
						letters: "contient au moins une des lettres",
					},
				},

				sqlOperators: {
					letters: { op: "= letters(?)" },
				},

				filters: [],
				icons: {
					add_group: "fas fa-plus-square",
					add_rule: "fas fa-plus-circle",
					remove_group: "fas fa-minus-square",
					remove_rule: "fas fa-minus-circle",
					error: "fas fa-exclamation-triangle",
				},
				operators: [
					{ type: "equal" },
					{ type: "not_equal" },
					{ type: "less" },
					{ type: "less_or_equal" },
					{ type: "greater" },
					{ type: "greater_or_equal" },
					{ type: "between" },
					{ type: "contains" },
					{ type: "not_contains" },
					{ type: "begins_with" },
					{ type: "ends_with" },
					{
						type: "is_empty",
						apply_to: ["string", "number", "datetime", "boolean"],
					},
					{
						type: "is_not_empty",
						apply_to: ["string", "number", "datetime", "boolean"],
					},
				],
			};

			for (var i = 0; i < this.columns.length; i++) {
				var type = "string";
				if (this.columns[i].type == "nombre") type = "double";
				this.config.filters.push({
					id:
						"`" +
						this.columns[i].colonne.replace(/'/gi, "\\'") +
						"`",
					label: this.columns[i].colonne,
					type: type,
				});
			}

			if (this.load_data) {
				this.load(this.load_data);
			}

			if (this.prev_data) {
				this.$refs.prev_data_tabulator.set_data(this.prev_data);
				this.$refs.prev_data_tabulator.redraw(true);
			}

			this.project_list.push();
			for (var i = 0; i < this.projects.length; i++) {
				this.project_list.push({
					value: this.projects[i].uid,
					text: this.projects[i].libelle,
				});
			}
			for (var i = 0; i < this.projects_archive.length; i++) {
				this.project_list.push({
					value: this.projects_archive[i].uid,
					text: this.projects_archive[i].libelle + ' (Archivé)',
				});
			}

			this.getMyServices();

			// ! sert à construire le JSON editor
			if (this.action_preset && this.load_data === null) {
				// this.action = this.action_preset.value;
				// this.actionLabel = this.action_preset.label;

				await this.setAction(
					this.action_preset.value,
					this.action_preset.label
				);
			}

			if (this.id.includes(" ")) {
				console.warn(
					"WARNING: id contains space, this may cause issues"
				);
			}

			if (this.show_user_params_editor) {
			var element = document.getElementById(
				'builder-user-params-' + this.action_id
			);

			this.editor_user_params = new JSONEditor(element, {
				schema: {
					type: "array",
					title: "Paramètres de traitements",
					items: {
						type: "object",
						title: "Paramètre",
						properties: {
							value: {
								options: { hidden: true }
							},
							step_uid: {
								options: { hidden: true },
								default: this.data.uid
							},
							name: {
								type: "string",
								title: "Nom"
							},
							libelle: {
								type: "string",
								title: "Nom à afficher"
							},
							description: {
								type: "string",
								title: "Description"
							},
							jsonpath: {
								type: "string",
								title: "Nom du champ dans le json ou jsonpath"
							},
							required: {
								type: "boolean",
								format: "checkbox",
								title: "Obligatoire",
								default: true
							},
							default: {
      							format: "textarea",
								title: "Valeur par défaut"
							},
							type: {
								title: "Type",
								type: "object",	
								oneOf: [
									{
										title: "Texte",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["texte"],
											},
											html_type: {
												title: "Type html",
												type: "string",
												enum: ["", "color", "date", "email", "month", "number", "password", "range", "tel", "time", "url", "week"]
											},
											datalist: {
												title: "Autocomplete",
												type: "array",
												format: "table",
												items: {
													type: "string",
													title: "Option"
												}
											},
											db: {
												title: "Liste autocomplete depuis la base de données",
												properties: {
													value: {
														title: "Clé",
														type: "string"
													},
													libelle: {
														title: "Valeur",
														type: "string"
													},
													table: {
														title: "Table",
														type: "string"
													},
													where: {
														title: "where",
														type: "string"
													},
													end: {
														title: "Fin de requête (limit, order by...)",
														type: "string"
													}
												}
											}
										},
									},
									{
										title: "Invisible",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["hidden"],
											}
										},
									},
									{
										title: "Vide",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["null"],
											}
										},
									},
									{
										title: "Zone de texte",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["textarea"],
											},
											rows: {
												title: "Nombre de lignes",
												type: "number",
												default: 5
											}
										},
									},
									{
										title: "Zone de texte avancée",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["textarea_plus"],
											}
										},
									},
									{
										title: "Editeur de JSON Schema",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["json_schema_editor"],
											}
										},
									},
									{
										title: "Cases à cocher",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["checkbox"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														}
													}
												}
											}
										},
									},
									{
										title: "Option a sélectionner",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["radio"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														}
													}
												}
											}
										},
									},
									{
										title: "Liste",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["list"],
											},
											multiple: {
												title: "Choix multiples",
												type: "boolean",
												format: "checkbox"
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														},
													}
												}
											},
											db: {
												title: "Liste depuis la base de données",
												properties: {
													value: {
														title: "Clé",
														type: "string"
													},
													libelle: {
														title: "Valeur",
														type: "string"
													},
													table: {
														title: "Table",
														type: "string"
													},
													where: {
														title: "where",
														type: "string"
													},
													end: {
														title: "Fin de requête (limit, order by...)",
														type: "string"
													}
												}
											}
										},
									},
									{
										title: "Valeurs avec autocompletion",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["autocomplete"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														text: {
															title: "Valeur",
															type: "string"
														}
													}
												}
											}
										},
									},
									{
										title: "Tableau de valeurs avec autocompletion",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["autocomplete_list"],
											},
											data_columns: {
												title: "Autocompletion avec les colonnes d'entrée",
												type: "string",
												enum: ["draggable"],
											},
											data_columns: {
												title: "Autocomplete avec les colonnes des fichiers",
												type: "boolean",
												format: "checkbox"
											},
											datalist: {
												title: "Autocomplete",
												type: "array",
												format: "table",
												items: {
													type: "string",
													title: "Option"
												}
											}
										},
									},
									{
										title: "Drag&drop - liste",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["draggable_list"],
											},
											options: {
												title: "Options",
												type: "array",
												format: "table",
												items: {
													type: "object",
													title: "Option",
													properties: {
														value: {
															title: "Clé",
															type: "string"
														},
														text: {
															title: "Valeur",
															type: "string"
														},
													}
												}
											}
										},
									},
									{
										title: "Tableau",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["csv"],
											}
										},
									},
									{
										title: "Objet",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["object"],
											}
										},
									},
									{
										title: "Base de données",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["database"],
											},
											table: {
												type: "string",
												title: "Table par défaut"
											}
										},
									},
									{
										title: "Base de données multitables",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["database multitables"],
											}
										},
									},
									{
										title: "Documents",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["documents"],
											}
										},
									},
									{
										title: "Zones",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["pdf_zones"],
											},
											type_doc: {
												title: "Colonne du type de document",
												type: "string",
											}
										},
									},
									{
										title: "Zones html",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["html_zones"],
											},
										},
									},
									{
										title: "Mapping",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["mapping"],
											},
										},
									},
									{
										title: "Docx",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["docx"],
											},
											type_doc: {
												title: "Colonne du type de document",
												type: "string",
											}
										},
									},
									{
										title: "Fichiers - noms",
										properties: {
											type: {
												title: "Type",
												type: "string",
												enum: ["file_names"],
											}
										},
									}
								]
							}
						}
					}
				},
				object_background: "",
				keep_oneof_values: false,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				prompt_before_delete: false,
			});

			this.editor_user_params.on("change", function () {
				self.user_params = self.editor_user_params.getValue();
				self.change_user_params();
			});
			}
		},
		beforeDestroy() {},
	};
</script>

<style>
	/* * pour que ce soit de la même hauteur que l'input description à côté 
    (formule prise de la classe form-control) */
	.vcs__picker input {
		height: calc(1.5em + 0.75rem + 2px) !important;
	}
</style>

<style scoped>
	.step-action-label {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 6px 0;
		min-height: 38px;
	}
	.step-action-name {
		font-size: 1rem;
		font-weight: 600;
		color: #1e293b;
	}
	.step-action-legacy-badge {
		font-size: 0.65rem;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.06em;
		color: #92400e;
		background: #fef3c7;
		border: 1px solid #f59e0b;
		border-radius: 4px;
		padding: 1px 6px;
	}
	.sub-menu {
		position: absolute;
		min-width: 10rem;
		padding: 0.5rem 0;
		margin: 0.125rem 0 0;
		font-size: 1rem;
		color: #212529;
		text-align: left;
		list-style: none;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid rgba(0, 0, 0, 0.15);
		border-radius: 0.25rem;
	}
</style>
